import React from 'react';
import { BreadcrumbsItem } from 'react-breadcrumbs-dynamic';
import BaseListContainer from '../../baseContainers/BaseListContainer';
import WeekViewService from '../../services/userReport/WeekViewService';
import { t } from 'i18next';
import { Column } from 'primereact/column';
import DivContainer from '../../components/DivContainer';
import { DataTable } from 'primereact/datatable';
import { ColumnGroup } from 'primereact/columngroup';
import { Row } from 'primereact/row';
import InputDropdownComponent from '../../components/inputs/InputDropdownComponent';
import InputCalendarComponent from '../../components/inputs/InputCalendarComponent';
import { CustomMessages } from '../../components/CustomMessages';
import BlockUi from '../../components/waitPanel/BlockUi';
import { Card } from 'primereact/card';
import moment, { weekdays } from 'moment';
import ProjectService from '../../services/ProjectService';
import { Inplace, InplaceDisplay, InplaceContent } from 'primereact/inplace';
import ActionLink from '../../components/ActionLink';
import YesNoDialog from '../../components/YesNoDialog';
import InputTextareaComponent from '../../components/inputs/InputTextareaComponent';
import SimpleReactValidator from '../../components/validator';
import { Prompt } from 'react-router-dom';
import UserRedirectWarningDialog from './UserRedirectWarningDialog';
import AuthService from '../../services/AuthService';
import ActionButton from '../../components/ActionButton';
import { TabPanel, TabView } from 'primereact/tabview';
import LogEntryListContainer from '../LogEntryListContainer';
import Constants from '../../utils/constants';
import ReportedUserDayService from '../../services/userReport/ReportedUserDayService';
import TimeRangeFormatter from './week/TimeRangeFormatter';
import UserTimeFormatter from './week/UserTimeFormatter';
import LegendDescriptionComponent from './LegendDescriptionComponent';
import WeekFormatter from './week/WeekFormatter';


const USER_APPROVED_COLUMN_COLOR = '#d4fae0';
const PM_APPROVED_COLUMN_COLOR = '#89faad';
const CREATIVE_TIME_INPUT_COLOR = '#FAFAD2';


class WeekViewContainer extends BaseListContainer {
    constructor(props) {
        super(props, new WeekViewService());
        const queryParams = new URLSearchParams(this.props.history.location.search);
        const day = queryParams.get('day');

        const date = new Date();
        date.setHours(0, 0, 0, 0);

        let activeIndexParam = parseInt(queryParams.get('activeIndex'));
        this.state = {
            dateParamValue: day && moment(day, 'YYYY-MM-DD', true).isValid()  ? day : null,
            list: [],
            activities: {
                map: {}
            },
            addRowActivities: {
                map: {}
            },  
            loading: true,
            size: 0,
            messageTypesOptions: [],
            first: 0,
            legendVisible: false,
            criteria: this.getCleanSearchCriteria(),
            dialogVisibile: false,
            viewMode: 'VIEW',
            isActiveModel: {
                map: {}
            },
            selectedWeek: 0,
            contractsForDays: [],
            handleEditComment: undefined,
            activeIndex: activeIndexParam ? activeIndexParam : 0,
            userDays: [],
            element: {
                events: [
                    [{
                        id: undefined,
                        reportedDayId: undefined,
                        userDayId: undefined,
                        userTime: null,
                        creativeTime: null,
                        timeFrom: null,
                        timeTo: null
                    }],
                    [{
                        id: undefined,
                        reportedDayId: undefined,
                        userDayId: undefined,
                        userTime: null,
                        creativeTime: null,
                        timeFrom: null,
                        timeTo: null
                    }],
                    [{
                        id: undefined,
                        reportedDayId: undefined,
                        userDayId: undefined,
                        userTime: null,
                        timeFrom: null,
                        timeTo: null
                    }],
                    [{
                        id: undefined,
                        reportedDayId: undefined,
                        userDayId: undefined,
                        userTime: null,
                        creativeTime: null,
                        timeFrom: null,
                        timeTo: null
                    }],
                    [{
                        id: undefined,
                        reportedDayId: undefined,
                        userDayId: undefined,
                        userTime: null,
                        creativeTime: null,
                        timeFrom: null,
                        timeTo: null
                    }],
                    [{
                        id: undefined,
                        reportedDayId: undefined,
                        userDayId: undefined,
                        userTime: null,
                        creativeTime: null,
                        timeFrom: null,
                        timeTo: null
                    }],
                    [{
                        id: undefined,
                        reportedDayId: undefined,
                        userDayId: undefined,
                        userTime: null,
                        creativeTime: null,
                        timeFrom: null,
                        timeTo: null
                    }]
                ],
            },
            startDateEndDateRequired: props.startDateEndDateRequired,
            showConfirmDeleteActivityDialog: false,
        };
        this.rowValidator = new SimpleReactValidator({}, this.translate); //walidator dla rekordow w liscie
        this.addRowValidator = new SimpleReactValidator({}, this.translate); //walidator dla wiersza, z ktorego dodaje sie nowe rekordy
        this.authService = new AuthService()

        const getMinutes = (moment) => {
            const hours = moment.hours();
            const minutes = moment.minutes();
            return hours * 60 + minutes;
        }

        //wyswietlanie odpowiednich danych na podstawie ustawień
        this.timeRenderRules =  [
            {
                //Tylko czas pracy
                isApplicable: (day)=> {
                    return !this.isStartEndDateRequired() && !this.isCreativeTimeColumnRequired(day);
                },
                render: (events, day)=> {
                    return this.userTimeTemplate(events[day], day);
                },
                renderDisplayValue: (event) =>{
                    return UserTimeFormatter(event, 'userTime');
                },
                renderTimeForRow: (rowIndex, columnIndex, day, index, isActiveModel, event)=> {
                    return this.renderUserTimeForRow(rowIndex, columnIndex, day, index, isActiveModel, event);
                }
            },
            {
               //Czas od do 
                isApplicable: () =>{
                    return this.isStartEndDateRequired();
                },
                render: (events, day)=> {
                    return this.fromToUserTimeTemplate(events[day], day);
                },
                renderDisplayValue: (event) =>{
                    return TimeRangeFormatter(event, 'timeFrom', 'timeTo');
                },
                renderTimeForRow: (rowIndex, columnIndex, day, index, isActiveModel, event) =>{
                    return this.renderFromToUserTimeForRow(rowIndex, columnIndex, day, index, isActiveModel, event);
                }
            },
            {
                 //Czas pracy + czas pracy twórczej
                isApplicable: (day) =>{
                    return this.isCreativeTimeColumnRequired(day);
                },
                render: (events, day) =>{
                    return this.userTimeAndCreativeTimeTemplate(events[day], day);
                },
                renderDisplayValue: (event)=> {
                    return `${UserTimeFormatter(event, 'userTime')}${event.creativeTime ? "(" + UserTimeFormatter(event, 'creativeTime') + ")" : ''}`;
                },
                renderTimeForRow: (rowIndex, columnIndex, day, index, isActiveModel, event)=> {
                    return this.renderUserTimeWithCreativeTimeForRow(rowIndex, columnIndex, day, index, isActiveModel, event);
                }
            },
        ]
        this.getValidTimeRenderRule = (day) => {
            const rules = this.timeRenderRules
            const validRule = rules.find(rule => rule.isApplicable(day));
            return validRule ? validRule : null;
        }

        this.summaryCalculators=[
            {
                //Tylko czas pracy
                isApplicable: (eventList) => {
                    return !this.isStartEndDateRequired() && this.authService.getProfile().featureCreativeWorkReportingEnabled === false
                },
                calculateRowSummary: (eventList) => {
                    let totalMinutes = 0;
                    eventList?.forEach((event) => {
                        if (event) {
                            totalMinutes += WeekViewDateUtils.formattedTimeToMinutes(moment(event.userTime).format('HH:mm'))
                        }
                    })
                    return WeekViewDateUtils.formatTime(totalMinutes);
                },
                calculateColumnSummary: (data, contracts) => {
                    let result = [0, 0, 0, 0, 0, 0, 0]
                    data.forEach((row) => {
                        row?.events.forEach((eventList, index) => {
                            let totalMinutes = result[index] //index -> kolumna
                            eventList?.forEach((event) => {
                                totalMinutes += WeekViewDateUtils.formattedTimeToMinutes(moment(event.userTime).format('HH:mm'))
                            })
                            result[index] = totalMinutes;
                        })
                    })

                    return result;
                }
            },
            {
                //Czas od do 
                isApplicable: () => {
                    return this.isStartEndDateRequired();
                },
                calculateRowSummary: (eventList) => {
                    let totalMinutes = 0;
                    eventList?.forEach((event) => {
                        if (event) {
                            totalMinutes += WeekViewDateUtils.formattedTimeToMinutes(moment(event.timeTo).format('HH:mm')) - WeekViewDateUtils.formattedTimeToMinutes(moment(event.timeFrom).format('HH:mm'))
                        }
                    })
                    return WeekViewDateUtils.formatTime(totalMinutes);
                },
                calculateColumnSummary: (data, contracts) => {
                    let result = [0, 0, 0, 0, 0, 0, 0]
                    data.forEach((row) => {
                        row?.events.forEach((eventList, index) => {
                            let totalMinutes = result[index] //index -> kolumna
                            eventList?.forEach((event) => {
                                totalMinutes += WeekViewDateUtils.formattedTimeToMinutes(moment(event.timeTo).format('HH:mm')) - WeekViewDateUtils.formattedTimeToMinutes(moment(event.timeFrom).format('HH:mm'))
                            })
                            result[index] = totalMinutes;
                        })
                    })

                    return result;
                }
            },
            {
                //Czas pracy + czas pracy twórczej
                isApplicable: (eventList) => {
                    return !this.isStartEndDateRequired() && this.authService.getProfile().featureCreativeWorkReportingEnabled === true
                },
                calculateRowSummary: (eventList, contracts) => {
                    let totalUserTimeMinutes = 0;
                    let totalCreativeTimeMinutes = 0;
                    eventList?.forEach((event, index) => {
                        if (event) {
                            totalUserTimeMinutes += WeekViewDateUtils.formattedTimeToMinutes(moment(event.userTime).format('HH:mm'))
                            if (event?.creativeTime && contracts[index] === 'PERNAMENT') {
                                totalCreativeTimeMinutes += WeekViewDateUtils.formattedTimeToMinutes(moment(event.creativeTime).format('HH:mm'))
                            }
                        }
                    })
                    return `${WeekViewDateUtils.formatTime(totalUserTimeMinutes)}${totalCreativeTimeMinutes ? "(" + WeekViewDateUtils.formatTime(totalCreativeTimeMinutes) + ")" : ""}`;
                },
                calculateColumnSummary: (data, contracts) => { 
                    let result = [[0, 0], [0, 0], [0, 0], [0, 0], [0, 0], [0, 0], [0, 0]]

                    data.forEach((row) => {
                        row?.events.forEach((eventList, index) => {
                            let totalMinutes = result[index][0]
                            let totalCreativeTimeMinutes = result[index][1]


                            eventList?.forEach((event) => {
                                totalMinutes += WeekViewDateUtils.formattedTimeToMinutes(moment(event.userTime).format('HH:mm'))
                                   if (event?.creativeTime && contracts[index] === 'PERNAMENT') {
                                    totalCreativeTimeMinutes += WeekViewDateUtils.formattedTimeToMinutes(moment(event.creativeTime).format('HH:mm'))
                                  }
                            })
                            result[index] = [totalMinutes, totalCreativeTimeMinutes]
                        })
                    })

                    //sformatowanie wyniku
                    let copy = [...result];
                    copy.forEach((record, index) => {
                        result[index] = `${WeekViewDateUtils.formatTime(record[0])}${record[1] ? "(" + WeekViewDateUtils.formatTime(record[1]) + ")" : ''}`;
                    })
                    return result;
                }
            },
        ]



        this.rowValidator.addCustomRule('from_less_than_to', t('userReporting.from_less_than_to'),
            (value, params) => {
                const rowIndex = params[2]
                const day = params[1]
                const index = params[0]

                const from = moment(this.state.list[rowIndex]?.events[day][index].timeFrom).toDate()
                const to = moment(this.state.list[rowIndex]?.events[day][index].timeTo).toDate()


                return (from.getMinutes() + from.getHours() * 60) < (to.getMinutes() + to.getHours() * 60)
            },
            (message, value) => message
        )

        this.rowValidator.addCustomRule('more_than_zero_week_row', t('userReporting.moreThanZeroValidaton'),
        (value, params) => {
            return moment(value).format('HH:mm') !== '00:00'
        }, (message, value) => message
        )

        this.rowValidator.addCustomRule('creative_time_validation', 'Czas pracy twórczej nie może przekraczać czasu pracy',
            (value, params) => {
                const rowIndex = params[2]
                const day = params[1]
                const index = params[0]

                const userTime = moment(this.state.list[rowIndex]?.events[day][index]?.userTime).toDate()
                const creativeTime = moment(this.state.list[rowIndex]?.events[day][index]?.creativeTime).toDate()

                if (this.state.list[rowIndex]?.events[day][index]?.creativeTime && this.state.list[rowIndex]?.events[day][index]?.userTime) {
                    // console.log(getMinutes(moment(creativeTime)) <= getMinutes(moment(userTime)));
                    // console.log(day);
                    return getMinutes(moment(creativeTime)) <= getMinutes(moment(userTime));
                } else {
                    return true;
                }
            }, (message, value) => message, true
        );

        this.rowValidator.addCustomRule('creative_time_at_least_one_minute',  'Należy wpisać czas pracy',
            (value, params) => {
                const rowIndex = params[2]
                const day = params[1]
                const index = params[0]

            
                const userTime = moment(this.state.list[rowIndex]?.events[day][index]?.userTime).toDate()
                const creativeTime = moment(this.state.list[rowIndex]?.events[day][index]?.creativeTime).toDate()

                if (userTime && creativeTime) {
                    return moment(creativeTime).format('HH:mm') !== '00:00' && moment(userTime).format('HH:mm') !== '00:00'
                }else{
                    return false;
                }
            }, (message, value) => message, true
        );


        this.addRowValidator.addCustomRule('more_than_zero', t('userReporting.moreThanZeroValidaton'),
            (value, params) => {
                const index = params[0]
                return moment(this.state.element.events[index][0]?.userTime).format('HH:mm') !== '00:00'
            }, (message, value) => message
        )

        this.addRowValidator.addCustomRule('from_less_than_to_add_row', t('userReporting.from_less_than_to_add_row'),
            (value, params) => {
                const index = params[0];
                const from = this.state.element.events[index][0].timeFrom;
                const to = this.state.element.events[index][0].timeTo;
                return from && to && from < to
            },
            (message, value) => message,
            true
        )


        this.addRowValidator.addCustomRule('creative_time_validation_add_row', 'Czas pracy twórczej nie może przekraczać czasu pracy',
            (value, params) => {
                const index = params[0];
                const userTime = this.state.element.events[index][0].userTime;
                const creativeTime = this.state.element.events[index][0].creativeTime;
            
                if (userTime && creativeTime) {
                    return getMinutes(moment(creativeTime)) <= getMinutes(moment(userTime))
                }else{
                    return true;
                }
            }, (message, value) => message, true
        );


        this.addRowValidator.addCustomRule('at_least_one_time_reported', t('userReporting.atLeastOneReported'),
            (value, params) => {
                const flag = this.isStartEndDateRequired()
                return this.state.element.events.flatMap((x) => x).map((x) => flag ? (x.timeFrom && x.timeTo) : x.userTime).filter((x) =>
                    x !== null).length >= 1
            }, (message, value) => message, true
        )

        this.dayViewService = new WeekViewService();
        this.projectService = new ProjectService();
        this.authService = new AuthService();
        this.userDayService = new ReportedUserDayService()

        this.isEmptyList = this.isEmptyList.bind(this);
        this.handleAddNewActivity = this.handleAddNewActivity.bind(this);
        this.decreaseSelectedWeek = this.decreaseSelectedWeek.bind(this);
        this.increaseSelectedWeek = this.increaseSelectedWeek.bind(this);
        this.handleEditActivity = this.handleEditActivity.bind(this);
        this.getUserTimeColumn = this.getUserTimeColumn.bind(this);
        this.getUserTimeColumnIfArray = this.getUserTimeColumnIfArray.bind(this);
        this.isRowActive = this.isRowActive.bind(this);
        this.isDirty = this.isDirty.bind(this);
        this.handleBeforeUnload = this.handleBeforeUnload.bind(this);
        this.loadActivitiesForRow = this.loadActivitiesForRow.bind(this);
        this.getIsAtLeastOneDayApproved = this.getIsAtLeastOneDayApproved.bind(this);
        this.rowIsEmpty = this.rowIsEmpty.bind(this);
    }

    componentDidMount() {
        super.componentDidMount();
        window.onbeforeunload = this.handleBeforeUnload; // handler do blokowania refresha lub przejscia na inny url
        this.closeInplacesIfSpecialCase();
    }

    isStartEndDateRequired() {
        return this.authService.getProfile().timeReportingStartEndDateRequired
    }

    isCreativeTimeColumnRequired(index, contracts) {
        const isStartEndNotRequired = !this.isStartEndDateRequired(); //tylko dla opcji z wpisywaniem ilości godzin
        const contract = contracts ? contracts[index] : this.state.contractsForDays[index];
        const userHasPernamentContractForDay = contract === 'PERNAMENT'; //i tylko kiedy user ma umowe o prace na dany dzień
        return this.authService.getProfile().featureCreativeWorkReportingEnabled === true && isStartEndNotRequired && userHasPernamentContractForDay
    }

    isDirty() {
        let atLeastOneFieldOpenFlag = false;
        const activeFields = this.state.isActiveModel.map;
        for (const [key, value] of Object.entries(activeFields)) {
            if (value) {
                atLeastOneFieldOpenFlag = true;
                break;
            }
        }
        return atLeastOneFieldOpenFlag;
    }

    handleBeforeUnload(event) {
        if (this.isDirty()) { //jesli chociaz jedno pole jest otwarte to zablokuj 
            event.preventDefault();
            return '';
        } else { //else, nie blokuj 
            return;
        }
    }



    closeInplacesIfSpecialCase() {
        const start = WeekViewDateUtils.getWeekRange(this.state.criteria.selectedDay)[0]
        const end = WeekViewDateUtils.getWeekRange(this.state.criteria.selectedDay)[1]

        const datesColumnsFirstIndex = 3
        const startDiff = moment(start).endOf('month').diff(start, 'days');
        const firstWeekColumns = Array.from({ length: startDiff + 1 }, (_, i) => i + 1).map(i => i + datesColumnsFirstIndex);

        const endDiff = end.diff(moment(end).startOf('month'), 'days')
        const secondWeekColumns = Array.from({ length: endDiff + 1 }, (_, i) => i + 1).map(i => i + firstWeekColumns[firstWeekColumns.length - 1]);
        
        this.setState({
            firstWeekColumns: firstWeekColumns,
            secondWeekColumns: secondWeekColumns
        });
    }

    updateSearchCriteria(criteria) {
        return {
            selectedDay: criteria.selectedDay
        };
    }

    getCleanSearchCriteria() {
        return {
            selectedDay: this.state?.dateParamValue ? moment(this.state?.dateParamValue) : moment() //default today
        };
    }



    afterGetListError() {
        this.showErrorMessage(t('userReporting.listError'), 10000);
    }

    initializeFromBackend() {
        const status = { enumValue: 'ACTIVE' }

        this.projectService.reportableProjects()
        .then(projects => this.setState({ projects: projects }))
        .catch(() => {
            this.showErrorMessage(t('userReporting.projectError'));
        });
    }


    getRowSummary(rowData, props) {
        const { summary } = this.state;
        const totalTime = summary.rowSummary[props.rowIndex] //podsumowanie dla wiersza
        return (
            <div
                style={{
                    display: 'flex',
                    justifyContent: 'start'
                }}>
                <div style={{ textAlign: 'center', fontWeight: '600' }}>
                    {totalTime}
                </div>
            </div>
        );
    }

    getList() {
        const {criteria} = this.state;
        const activeElement = document.activeElement;

        const getColumnSummary = (data, contracts) => {
            let calculator = this.summaryCalculators.find(x => x.isApplicable(data.flatMap(x => x.events).flatMap(x => x))) //musi byc jakas zmienna reprezentujaca dzien, user moze miec do polowy tyg. zlecenie i potem od kolejnego dnia umowe o prace.
            return calculator?.calculateColumnSummary(data, contracts)
        }

        const getSummarizedRow = (data, contracts) => {
            let totalMinutesList = []
            const calculators = this.summaryCalculators;
            data?.forEach((row, index) => {
                let calculator = calculators.find(x => x.isApplicable(row.events.flatMap(x => x))) //musi byc jakas zmienna reprezentujaca dzien, user moze miec do polowy tyg. zlecenie i potem od kolejnego dnia umowe o prace.
                totalMinutesList[index] = calculator?.calculateRowSummary(row.events.flatMap(x => x), contracts)
            })
            return totalMinutesList
        }

        this.setState(
            {
                loading: true,
            },
            () => {
                this.service
                    .getList(criteria)
                    .then((data) => {
                        if (this._isMounted) {
                            this.setState(
                                {
                                    list: this.updateListElements(data.list),
                                    loading: false,
                                    contractsForDays: data?.contractsForDays,
                                    summary: {
                                        rowSummary: getSummarizedRow(data.list, data?.contractsForDays),
                                        columnSummary: getColumnSummary(data.list, data?.contractsForDays)
                                    },
                                    size: data.list.totalElements,
                                    userDays: data.userDayIds
                                },
                                () => { 
                                    this.setTimeout(() => activeElement?.focus(), 50);
                                }
                            );
                        }
                    })
                    .catch((err) => {
                        console.log(err);
                        if (this._isMounted) {
                            this.setState(
                                {
                                    list: [],
                                    loading: false,
                                    summary: {
                                        rowSummary: [],
                                        columnSummary: []
                                    },
                                    size: 0,
                                },
                                () => {
                                    this.afterGetListError();
                                }
                            );
                        }
                    });
            }
        );
    }


    normalizeListAfterRowEdit(list){
        //moze byc case ze user zedytuje kilka pol w kilku wierszach
        // i bedzie kazdy wiersz po kolei zapisywac 
        // przy zapisie edycji jest refresh listy wiec juz po jednym zapisie wszystkim polom przypisana zostanie wartosc z bazy 
        // i user bedzie musial od nowa edytowac.
        let rowsToIgnore = []
        const data = this.state.isActiveModel.map;
        for (const [key, value] of Object.entries(data)) {
            const arr = key.split(',').map(Number);
            if (value) { //jesli dla danej kolumny jest ustawione true
                rowsToIgnore.push(
                    arr[0] //dodaj, ktory wiersz nalezy "zignorowac"
                );
            }
        }
        const currentList = this.state.list; //obecne wartosci z listy

        return list.map((valueFromDb, index) => 
           rowsToIgnore.includes(index) ? currentList[index] : valueFromDb
            //jesli indeks matchuje sie z wierszem do "zignorowania", ustaw wartosc ze state else wez zaktualizowana wartosc
         ); //wtedy po zapisie user zachowa zmiany w innych edytowanych wierszach
    }
    
    updateListElements(list) {
        return this.normalizeListAfterRowEdit(list);
    }

    getListTitle() {
        return '';
    }

    fromToUserTimeTemplate(element, index) {
        // FROM - TO, 8 am - 2 pm.
        const isDisabled = this.getIsColumnShouldBeDisabled(index + 4);
        return (
            <div className='row' style={{paddingLeft:'23px'}}>
                <div style={{ '--bs-gutter-x': '0.0rem', maxWidth:"90px"}} className='row'>
                    <div className='col'>
                        <InputCalendarComponent
                            id={isDisabled ? `disabled-time-from-add-row-${index}` : `time-from-add-row-${index}`}
                            name={`timeFrom`}
                            value={element[0].timeFrom}
                            onChange={(a, b, c) => {
                                const newList = [...this.state.element.events];
                                newList[index][0].timeFrom = c.target.value;
                                this.setState((prev) => ({
                                    element: {
                                        ...prev.element,
                                        events: newList,
                                    },
                                }));
                            }}
                            label={t('userReporting.workTime')}
                            showLabel={false}
                            insideTable
                            showTime
                            validateViewMode={false}
                            validator={this.addRowValidator}
                            validators={`from_less_than_to_add_row:${index + 4}`}
                            dateFormatMoment="HH:mm"
                            timeOnly
                            placeholder="HH:mm"
                            className="user-reporting-time-style"
                            showSeconds={false}
                            showIcon={false}
                            icon={() => <i className="clock" />}
                            readOnlyInput={false}
                            propCustomValue={true}
                            viewMode={'NEW'}
                            mask="99:99"
                            disabled={isDisabled ? true : false}
                            style={{
                                maxWidth: '40px',
                                boxSizing: 'border-box',
                            }}
                            customTimePicker={() => {
                                return (
                                    <InputTextareaComponent
                                        label={t('userReporting.comment')}
                                        value={this.state.element.events[index][0].comment}
                                        showLabel={true}
                                        insideTable
                                        rendered={true}
                                        onChange={(a, b, c, d) => {
                                            const newList = [...this.state.element.events];
                                            newList[index][0].comment = c.target.value;
                                            this.setState((prev) => ({
                                                element: {
                                                    ...prev.element,
                                                    events: newList,
                                                },
                                            }));
                                        }}
                                        maxlength={500}
                                        viewMode={'NEW'}
                                        autoResize
                                        className='report-week-comment'
                                    />
                                );
                            }}
                            onInputClick={(id) => {
                                const input = document.getElementById(id)
                                input.focus();
                                input.setSelectionRange(0, 0);
                            }}
                        />

                    </div>
                    <div className='col'>
                        <InputCalendarComponent
                            id={isDisabled ? `disabled-time-to-add-row-${index}` : `time-to-add-row-${index}`}
                            name={`timeTo`}
                            value={element[0].timeTo}
                            onChange={(a, b, c) => {
                                const newList = [...this.state.element.events];
                                newList[index][0].timeTo = c.target.value;
                                this.setState((prev) => ({
                                    element: {
                                        ...prev.element,
                                        events: newList,
                                    },
                                }));
                            }}
                            label={t('userReporting.workTime')}
                            showLabel={false}
                            insideTable
                            showTime
                            validateViewMode={false}
                            validator={this.addRowValidator}
                            validators={`from_less_than_to_add_row:${index + 4}`}
                            dateFormatMoment="HH:mm"
                            timeOnly
                            placeholder="HH:mm"
                            className="user-reporting-time-style"
                            showSeconds={false}
                            showIcon={false}
                            icon={() => <i className="clock" />}
                            readOnlyInput={false}
                            propCustomValue={true}
                            viewMode={'NEW'}
                            mask="99:99"
                            disabled={isDisabled ? true : false}
                            style={{
                                maxWidth: '40px',
                                boxSizing: 'border-box',
                            }}
                            customTimePicker={() => {
                            }}
                            onInputClick={(id) => {
                                const input = document.getElementById(id)
                                input.focus();
                                input.setSelectionRange(0, 0);
                            }}
                        />
                    </div>
                </div>
            </div>
        );
    }

    userTimeAndCreativeTimeTemplate(element, index) {
        const isDisabled = this.getIsColumnShouldBeDisabled(index + 4);

        const style = {
            maxWidth: '40px',
            boxSizing: 'border-box',
        }
     
        return (
            <div className='row'>
                <div style={{ '--bs-gutter-x': '0.2rem', maxWidth:'90px'}} className='row'>
                    <div className='col'>
                        <InputCalendarComponent
                            id={isDisabled ? `disabled-userTime-${index}` : `userTime-${index}`}
                            name={'userTime'}
                            value={element[0].userTime}
                            onChange={(a, b, c) => {
                                const newList = [...this.state.element.events];
                                newList[index][0].userTime = c.target.value;
                                this.setState((prev) => ({
                                    element: {
                                        ...prev.element,
                                        events: newList,
                                    },
                                }));
                            }}
                            label={t('userReporting.workTime')}
                            showLabel={false}
                            insideTable
                            showTime
                            validator={this.addRowValidator}
                            validateViewMode={false}
                            validators={'at_least_one_time_reported|more_than_zero_week_row'}
                            dateFormatMoment="HH:mm"
                            timeOnly
                            placeholder="HH:mm"
                            className="user-reporting-time-style"
                            showSeconds={false}
                            showIcon={false}
                            icon={() => <i className="clock" />}
                            readOnlyInput={false}
                            propCustomValue={true}
                            viewMode={'NEW'}
                            mask="99:99"
                            disabled={isDisabled ? true : false}
                            style={style}
                            customTimePicker={() => {
                                return (
                                    <InputTextareaComponent
                                        label={t('userReporting.comment')}
                                        value={this.state.element.events[index][0].comment}
                                        showLabel={true}
                                        insideTable
                                        rendered={true}
                                        onChange={(a, b, c, d) => {
                                            const newList = [...this.state.element.events];
                                            newList[index][0].comment = c.target.value;
                                            this.setState((prev) => ({
                                                element: {
                                                    ...prev.element,
                                                    events: newList,
                                                },
                                            }));
                                        }}
                                        maxlength={500}
                                        viewMode={'NEW'}
                                        autoResize
                                        className='report-week-comment'
                                    />
                                );
                            }}
                            onInputClick={(id) => {
                                const input = document.getElementById(id)
                                input.focus();
                                input.setSelectionRange(0, 0);
                            }}
                        />
                    </div>
                    <div className='col' style={{}}>
                        <InputCalendarComponent
                            id={isDisabled ? `disabled-creativeTime-${index}` : `creativeTime-${index}`}
                            name={'userTime'}
                            value={element[0].creativeTime}
                            onChange={(a, b, c) => {
                                const newList = [...this.state.element.events];
                                newList[index][0].creativeTime = c.target.value;
                                this.setState((prev) => ({
                                    element: {
                                        ...prev.element,
                                        events: newList,
                                    },
                                }));
                            }}
                            label={t('userReporting.creativeTime')}
                            showLabel={false}
                            insideTable
                            showTime
                            validator={this.addRowValidator}
                            validateViewMode={false}
                            validators={`at_least_one_time_reported|more_than_zero_week_row|creative_time_validation_add_row:${index}`}
                            dateFormatMoment="HH:mm"
                            timeOnly
                            placeholder="HH:mm"
                            className="week-view-creative-time-wrapper"
                            showSeconds={false}
                            showIcon={false}
                            icon={() => <i className="clock" />}
                            readOnlyInput={false}
                            propCustomValue={true}
                            viewMode={'NEW'}
                            mask="99:99"
                            disabled={isDisabled ? true : false}
                            style={style}
                            customTimePicker={() => { }}
                            onInputClick={(id) => {
                                const input = document.getElementById(id)
                                input.focus();
                                input.setSelectionRange(0, 0);
                            }}
                        />
                    </div>
                </div>
            </div>
        );
    }


    userTimeTemplate(element, index) {
        const isDisabled = this.getIsColumnShouldBeDisabled(index + 4);
        return (
            <div style={{
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center'
            }}>
                <InputCalendarComponent
                    id={isDisabled ? `disabled-userTime-${index}` : `userTime-${index}`}
                    name={'userTime'}
                    value={element[0].userTime}
                    onChange={(a, b, c) => {
                        const newList = [...this.state.element.events];
                        newList[index][0].userTime = c.target.value;
                        this.setState((prev) => ({
                            element: {
                                ...prev.element,
                                events: newList,
                            },
                        }));
                    }}
                    label={t('userReporting.workTime')}
                    showLabel={false}
                    insideTable
                    showTime
                    validator={this.addRowValidator}
                    validateViewMode={false}
                    validators={'at_least_one_time_reported|more_than_zero_week_row'}
                    dateFormatMoment="HH:mm"
                    timeOnly
                    placeholder="HH:mm"
                    className="user-reporting-time-style"
                    showSeconds={false}
                    showIcon={false}
                    icon={() => <i className="clock" />}
                    readOnlyInput={false}
                    propCustomValue={true}
                    viewMode={'NEW'}
                    mask="99:99"
                    disabled={isDisabled ? true : false}
                    style={{
                        width: '50px',
                        maxWidth: '60px',
                        boxSizing: 'border-box',
                    }}
                    customTimePicker={() => {
                        return (
                            <InputTextareaComponent
                                label={t('userReporting.comment')}
                                value={this.state.element.events[index][0].comment}
                                showLabel={true}
                                insideTable
                                rendered={true}                                
                                onChange={(a, b, c, d) => {
                                    const newList = [...this.state.element.events];
                                    newList[index][0].comment = c.target.value;
                                    this.setState((prev) => ({
                                        element: {
                                            ...prev.element,
                                            events: newList,
                                        },
                                    }));
                                }}                                
                                maxlength={500}
                                viewMode={'NEW'}
                                autoResize
                                className='report-week-comment'
                            />
                        );
                    }}
                    onInputClick={(id) => {
                        const input = document.getElementById(id)
                        input.focus();
                        input.setSelectionRange(0, 0);
                    }}
                />
            </div>
        );
    }

    handleAddNewActivity() {
        const newElement = this.state.element;
        if (this.addRowValidator.allValid()) {
            this.setState(
                {
                    loading: true,
                }, () => {
                    this.dayViewService
                        .add(newElement, this.state.criteria.selectedDay)
                        .then((x) => {
                            if (this._isMounted) {
                                this.setState(
                                    {
                                        loading: false,
                                        element: {
                                            events: [
                                                [{
                                                    id: undefined,
                                                    reportedDayId: undefined,
                                                    userDayId: undefined,
                                                    userTime: null,
                                                    creativeTime: null,
                                                    timeFrom: null,
                                                    timeTo: null
                                                }],
                                                [{
                                                    id: undefined,
                                                    reportedDayId: undefined,
                                                    userDayId: undefined,
                                                    userTime: null,
                                                    creativeTime: null,
                                                    timeFrom: null,
                                                    timeTo: null
                                                }],
                                                [{
                                                    id: undefined,
                                                    reportedDayId: undefined,
                                                    userDayId: undefined,
                                                    userTime: null,
                                                    timeFrom: null,
                                                    timeTo: null
                                                }],
                                                [{
                                                    id: undefined,
                                                    reportedDayId: undefined,
                                                    userDayId: undefined,
                                                    userTime: null,
                                                    creativeTime: null,
                                                    timeFrom: null,
                                                    timeTo: null
                                                }],
                                                [{
                                                    id: undefined,
                                                    reportedDayId: undefined,
                                                    userDayId: undefined,
                                                    userTime: null,
                                                    creativeTime: null,
                                                    timeFrom: null,
                                                    timeTo: null
                                                }],
                                                [{
                                                    id: undefined,
                                                    reportedDayId: undefined,
                                                    userDayId: undefined,
                                                    userTime: null,
                                                    creativeTime: null,
                                                    timeFrom: null,
                                                    timeTo: null
                                                }],
                                                [{
                                                    id: undefined,
                                                    reportedDayId: undefined,
                                                    userDayId: undefined,
                                                    userTime: null,
                                                    creativeTime: null,
                                                    timeFrom: null,
                                                    timeTo: null
                                                }]
                                            ],
                                        }
                                    },
                                    () => {
                                        this.refreshTable();
                                    }
                                );
                                this.addRowValidator.hideMessages()
                            }
                        }).catch((err) => {
                            if (this._isMounted) {
                                this.showErrorMessage(err.message);
                                this.setState(
                                    {
                                        loading: false,
                                    },
                                    () => {
                                        this.refreshTable();
                                    }
                                );
                                this.addRowValidator.hideMessages()
                            }
                        })
                }
            );
        } else {
            this.addRowValidator.showMessages();
            //this.scrollToError = true;
            this.forceUpdate();
        }
    }


    handleEditActivity(rowData, rowIndex) {
        if (this.rowValidator.allValid()) {
            const data = this.getClosedInplaceComponentsMapForRow(rowIndex);
            this.setState(
                {
                    loading: true,
                }, () => {
                    this.dayViewService
                        .update(rowData, this.state.criteria.selectedDay, this.state.selectedWeek)
                        .then((x) => {
                            if (this._isMounted) {
                                this.setState(
                                    {
                                        loading: false,
                                        isActiveModel: {
                                            map: data
                                        }
                                    },
                                    () => {
                                        this.refreshTable();
                                    }
                                );
                            }
                        }).catch((err) => {
                            if (this._isMounted) {
                                this.showErrorMessage(err.message);
                                this.setState(
                                    {
                                        loading: false,
                                    },
                                    () => {
                                        this.refreshTable();
                                    }
                                );
                            }
                        })
                }
            );
        } else {
            console.log(21812)
            this.rowValidator.showMessages();
            this.scrollToError = true;
            this.forceUpdate();
        }
    }

    isRowActive(rowIndex) {
        const data = this.state.isActiveModel.map;
        for (const [key, value] of Object.entries(data)) {
            const arr = key.split(',').map(Number);
            if (arr[0] === rowIndex && data[[arr[0], arr[1]]]) { //jesli dla danej kolumny jest ustawione true
                return true;
            }
        }
        return false;
    }
    

    renderAddRow() {
        const { summary } = this.state;
        const { list } = this.state;

    
        const renderUserTimeForAddRow = (day) => {
            return this.getValidTimeRenderRule(day).render(this.state.element.events, day)
        }

        const flag = this.isStartEndDateRequired()
        const atLeastOnePermanentContract = this.state.contractsForDays.filter(x => x === 'PERNAMENT').length >= 1;
        const featureEnabled = this.authService.getProfile().featureCreativeWorkReportingEnabled

        const emptyMessageRow = flag || (atLeastOnePermanentContract && featureEnabled) ? <Row>
            <Column footer="" colSpan={4} footerStyle={{ textAlign: "center", backgroundColor: '#f4f5fc' }} />
            <Column footer="Brak danych do wyświetlenia - Dodaj nowy wpis" colSpan={2} footerStyle={{ textAlign: "center", backgroundColor: '#f4f5fc' }} />
            <Column footer="" colSpan={1} footerStyle={{ textAlign: "center", backgroundColor: '#f4f5fc' }} />
        </Row> : <Row>
            <Column footer="" colSpan={4} footerStyle={{ textAlign: "center", backgroundColor: '#f4f5fc' }} />
            <Column footer="Brak danych do wyświetlenia - Dodaj nowy wpis" colSpan={2} footerStyle={{ textAlign: "center", backgroundColor: '#f4f5fc' }} />
            <Column footer="" colSpan={1} footerStyle={{ textAlign: "center", backgroundColor: '#f4f5fc' }} />
        </Row>

    
        return (
            <ColumnGroup>
                {list.length >= 1 ?
                    <Row>
                        <Column footer="Podsumowanie" footerStyle={{ textAlign: "right" }} />
                        <Column footer='' colSpan={2} footerStyle={{ textAlign: 'right' }} />
                        <Column footer={summary?.columnSummary[0] ? `${(summary?.columnSummary[0])}` : '00:00'} footerStyle={{ textAlign: 'center' }} />
                        <Column footer={summary?.columnSummary[1] ? `${(summary?.columnSummary[1])}` : '00:00'} footerStyle={{ textAlign: 'center' }} />
                        <Column footer={summary?.columnSummary[2] ? `${(summary?.columnSummary[2])}` : '00:00'} footerStyle={{ textAlign: 'center' }} />
                        <Column footer={summary?.columnSummary[3] ? `${(summary?.columnSummary[3])}` : '00:00'} footerStyle={{ textAlign: 'center' }} />
                        <Column footer={summary?.columnSummary[4] ? `${(summary?.columnSummary[4])}` : '00:00'} footerStyle={{ textAlign: 'center' }} />
                        <Column footer={summary?.columnSummary[5] ? `${(summary?.columnSummary[5])}` : '00:00'} footerStyle={{ textAlign: 'center' }} />
                        <Column footer={summary?.columnSummary[6] ? `${(summary?.columnSummary[6])}` : '00:00'} footerStyle={{ textAlign: 'center' }} />
                        <Column />
                        <Column />
                    </Row>
                    : null
                }
                {list.length === 0 ?
                    emptyMessageRow : null
                }
                <Row>
                    <Column style={{
                        position: 'static'
                    }} footer={() => {
                        //KLIENT
                        return (
                            <InputDropdownComponent
                                id='client-row'
                                name='client'
                                value={this.state.element?.project?.client}
                                validator={this.addRowValidator}
                                options={this.state.projects}
                                onChange={this.handleChange}
                                viewMode={'VIEW'}
                                optionLabel='name'
                                dataKey='id'
                                validators='required|record_already_assigned'
                                label={t('userReporting.project')}
                                showLabel={false}
                                placeholder={t('userReporting.project')}
                                filter
                                filterBy='name'
                                className='custom-dropdown'
                                insideTable
                                style={{
                                    height: '35px',
                                    boxSizing: 'border-box'
                                }}
                            />
                        )
                    }} />
                    <Column style={{
                        width: '500px'
                    }} footer={() => {
                        //PROJEKT
                        return (
                            <InputDropdownComponent
                                id='project-drodpown-add-row'
                                name='project'
                                value={this.state.element?.project}
                                validator={this.addRowValidator}
                                validators='required'
                                options={this.state.projects}
                                onChange={this.handleChange}
                                viewMode={'NEW'}
                                optionLabel='name'
                                className='custom-dropdown'
                                dataKey='id'
                                label={t('userReporting.project')}
                                showLabel={false}
                                placeholder={t('userReporting.project')}
                                style={{
                                    height: '35px',
                                    maxWidth: '100%',
                                    width: '100%',
                                    boxSizing: 'border-box'
                                }}
                                filter
                                filterBy='name'
                                insideTable
                                onAfterStateChange={(e) => {
                                    this.projectService
                                        .getTimeReportingActivities(this.state.element?.project.id)
                                        .then(activities => {
                                            if (!activities.map((x) => x?.id).includes(this.state.element.activity?.id)) {
                                                //usun aktywnosc jesli nie jest przypisana do wybranego projektu
                                                this.state.element.activity = null
                                            }
                                            this.setState(({
                                                addRowActivities: {
                                                    map: activities
                                                }
                                            }))
                                        }).catch(() => {
                                            this.setState({
                                                addRowActivities: {
                                                    map: {}
                                                }
                                            })
                                            this.showErrorMessage(t('userReporting.projectError'));
                                        })
                                }}
                            />
                        )
                    }}
                    />
                    <Column
                        footer={() => {
                            //AKTYWNOŚĆ
                            return (
                                <div>
                                    <InputDropdownComponent
                                        id='activity'
                                        name='activity'
                                        value={this.state.element?.activity}
                                        disabled={this.state.element?.project === undefined ? true : false}
                                        colClass='col-xl-12 col-lg-12 col-md-12 col-sm-12'
                                        validator={this.state.element?.project === undefined ? null : this.addRowValidator}
                                        validators='required'
                                        options={this.state.addRowActivities.map}
                                        onChange={this.handleChange}
                                        viewMode={'NEW'}
                                        optionLabel='name'
                                        dataKey='id'
                                        placeholder={t('userReporting.activity')}
                                        label={t('userReporting.activity')}
                                        showLabel={false}
                                        className='custom-dropdown'
                                        style={{
                                            height: '35px',
                                            maxWidth: '100%',
                                            width: '100%',
                                            boxSizing: 'border-box'
                                        }}
                                        filter
                                        filterBy='name'
                                        insideTable
                                    />
                                </div>
                            )
                        }}
                    />
                    <Column
                        style={{
                            width: '92px',
                            minWidth: '92px',
                        }}
                        footer={() => {
                            return (
                                renderUserTimeForAddRow(0)
                            );
                        }}
                    />
                    <Column
                        style={{
                            width: '92px',
                            minWidth: '92px',
                        }}
                        footer={() => {
                            return (
                                renderUserTimeForAddRow(1)
                            );
                        }}
                    />
                    <Column
                        style={{
                            width: '92px',
                            minWidth: '92px',
                        }}
                        footer={() => {
                            return (
                                <div>
                                    {renderUserTimeForAddRow(2)}
                                    <div
                                        style={{
                                            position: 'absolute'
                                        }}
                                    >
                                        <span>
                                            {this.addRowValidator.message(
                                                '',
                                                '',
                                                '',
                                                [
                                                    'at_least_one_time_reported',
                                                    ...Array.from({ length: 7 }, (_, i) => `from_less_than_to_add_row:${i}`),
                                                    ...Array.from({ length: 7 }, (_, i) => `creative_time_validation_add_row:${i}`)
                                                ].join('|')
                                            )}
                                        </span>
                                    </div>
                                </div>
                            );
                        }}
                    />
                    <Column
                        style={{
                            width: '92px',
                            minWidth: '92px',
                        }}
                        footer={() => {
                            return renderUserTimeForAddRow(3);
                        }}
                    />
                    <Column
                        style={{
                            width: '92px',
                            minWidth: '92px',
                        }}
                        footer={() => {
                            return (
                                renderUserTimeForAddRow(4)
                            );
                        }}
                    />
                    <Column
                        style={{
                            width: '92px',
                            minWidth: '92px',
                        }}
                        footer={() => {
                            return (
                                renderUserTimeForAddRow(5)
                            );
                        }}
                    />
                    <Column
                        style={{
                            width: '92px',
                            minWidth: '92px',
                        }}
                        footer={() => {
                            return (
                                renderUserTimeForAddRow(6)
                            );
                        }}
                    />
                    <Column
                        colSpan={2}
                        style={{
                            width: '50px'
                        }}
                        footer={() => {
                            return (
                                <ActionButton
                                    id='addRowButton'
                                    label={'Zapisz'}
                                    handleClick={this.handleAddNewActivity.bind(this)}
                                    style={{
                                        width: "fit-content"
                                    }} />
                            )
                        }}
                    />
                </Row>
            </ColumnGroup>
        );
    }


    footerGroup() {
        return this.renderAddRow()
    }

    generateCustomFooterIfPossible() {
        return this.footerGroup();
    }

    isEmptyList() {
        return this.state.list.length === 0;
    }


    onToggleFunction(rowIndex, columnIndex, isActiveModel) {
        let data = isActiveModel.map;
        if (data[[rowIndex, columnIndex]] === undefined || data[[rowIndex, columnIndex]] === false) {
            data[[rowIndex, columnIndex]] = true;
            this.setState({
                isActiveModel: {
                    map: data
                }
            })
        }
    }


    renderDataTable(columns, list, size) {
        const {criteria, first, loading} = this.state;
        if (list === null || list === undefined) {
            list = this.props.list ? this.props.list : this.state.list;
        }
        if (size === null || size === undefined) {
            size = this.props.list ? this.props.size : this.state.size;
        }

        let weekStart = WeekViewDateUtils.getWeekRange(criteria.selectedDay);
        let start = weekStart[0];
        start.subtract(1, 'day')

        const isSpecialCase = WeekViewDateUtils.isSpecialWeek(this.state.criteria.selectedDay);
        const { selectedWeek } = this.state;
        const dynamicColumns = columns.map((col, index) => {
            //jesli tydzien jest "przechodni", sprawdz czy kolumne wyszarzyc 
            const indexToCheck = isSpecialCase ? (selectedWeek === 1 ? this.state?.firstWeekColumns?.includes(index + 1) : this.state?.secondWeekColumns?.includes(index + 1)) : null
            return (
                <Column
                    selectionMode={col.selectionMode}
                    key={col.key ? col.key : col.field}
                    field={col.field}
                    filter
                    filterField={col.field}
                    showFilterMenu={false}
                    header={(index <= 2 || index >= 10) ? col.header : WeekViewDateUtils.getTimeHeader(start.add(1, 'day').format('DD'), index - 3)}
                    body={col.body}
                    bodyClassName={col.bodyClassName}
                    headerClassName={col.headerClassName}
                    className={col.className}
                    sortable={col.sortable}
                    sortField={col.sortField !== undefined ? col.sortField : col.field}
                    style={col.style ? col.style : col.width !== undefined ? { width: col.width, maxWidth: col.width } : col.minWidth ? { minWidth: col.minWidth } : null}
                    columnIndex={index}
                    bodyStyle={{
                        ...(indexToCheck ? { backgroundColor: '#f2f2f2' } : {}),
                    }}
                />
            );
        });    
        const rowsPerPageOptions = [5, 10, 20, 50, 100];
        const isEmpty = this.isEmptyList();


        let events = []
        if (WeekViewDateUtils.isSpecialWeek(this.state.criteria.selectedDay)) {
            events = [...new Set(this.getCurrentWeekEvents().filter((x) => x !== undefined))]
        } else {
            events = [...new Set(this.state.list.flatMap((x) => x.events).flatMap(x => x)
                .filter(x => x))]
        }
        const isPm = this.authService.isUserInAnyRoleArray(['ROLE_TIMESHEET_APPROVE'])

        const atLeastOneToApprove = this.state.list.length > 0 && events.map(x => x?.acceptLevel).filter((x) => x === Constants.TO_APPROVE_BY_USER_LEVEL).length > 0
        const atLeastOneToUnlock = this.state.list.length > 0 &&
            events.map(x => x?.acceptLevel).filter((x) => isPm ? x === Constants.PM_APPROVED_LEVEL : x === Constants.TO_APPROVE_BY_PM_LEVEL).length > 0

        return (
            <React.Fragment>
                <DivContainer colClass='row'>
                    <div className=''>
                        <DataTable
                            id='dataTable'
                            key='data-table'
                            unstyled={true}
                            emptyMessage={t('list.empty')}
                            className={isEmpty ? 'empty-table' : 'p-datatable-responsive'}
                            breakpoint='10px'
                            value={list}
                            paginator={false}
                            footerColumnGroup={this.generateCustomFooterIfPossible()}
                            globalFilterFields={this.globalFilterFields()}
                            filters={this.state.filters}
                            rows={criteria.maxResults}
                            totalRecords={size}
                            first={first}
                            rowsPerPageOptions={rowsPerPageOptions}
                            sortField={criteria.sortField}
                            sortOrder={criteria.sortAsc ? 1 : -1}
                            loading={loading}
                            //responsiveLayout={'scroll'}
                            paginatorPosition='bottom'
                            cellClassName={(rowData, props) => {
                                const columnIndex = props.column.props.columnIndex
                                const mondayColumnIndex = 3
                                const events = props.rowData.events[columnIndex - mondayColumnIndex]

                                const isUserApproved = events && events.length > 0 && events?.flatMap(x => x.acceptLevel).filter(x => x === Constants.TO_APPROVE_BY_PM_LEVEL).length === events?.flatMap(x => x.acceptLevel).length
                                    && events?.flatMap(x => x.acceptLevel).filter(x => x === Constants.TO_APPROVE_BY_PM_LEVEL).length === events?.flatMap(x => x.acceptLevel).length

                                const flag = events?.flatMap(x => x.acceptLevel).filter(x => x === Constants.PM_APPROVED_LEVEL).length === events?.flatMap(x => x.acceptLevel).length
                                const isPmApproved = events && events.length > 0 && flag
                                return columnIndex >= 3 && isUserApproved ? {
                                    'user-approved-cell': true
                                } : (columnIndex >= 3 && isPmApproved ? {
                                    'pm-approved-cell': true
                                } : null)
                            }}
                            footer={(e)=>{
                                return (
                                    <div
                                        style={{
                                            display: 'flex',
                                            justifyContent: 'end',
                                            gap: '10px'
                                        }}
                                    >
                                        <div
                                            style={{
                                                marginRight: 'auto'
                                            }}
                                        >
                                            {<LegendDescriptionComponent
                                                legendItems={[
                                                    {
                                                        name: 'Aktywność zaakceptowana przez użytkownika',
                                                        hex: USER_APPROVED_COLUMN_COLOR
                                                    },
                                                    {
                                                        name: 'Aktywność zaakceptowana przez PM',
                                                        hex: PM_APPROVED_COLUMN_COLOR
                                                    },
                                                    ...(this.authService.getProfile().featureCreativeWorkReportingEnabled
                                                        ? [{ name: 'Praca twórcza', hex: CREATIVE_TIME_INPUT_COLOR }]
                                                        : [])
                                                ]}
                                            />}
                                        </div>
                                        {this.state.activeIndex === 1 ? null : (
                                            <>
                                                {atLeastOneToApprove && !this.isDirty() ? (
                                                    <ActionButton
                                                        id='accept-button'
                                                        label={t('userReporting.confirm')}
                                                        className="float-right header-item"
                                                        handleClick={() => {
                                                            this.setState({ approveDialogVisible: true });
                                                        }}
                                                    />
                                                ) : null}

                                                {atLeastOneToUnlock && !this.isDirty() ? (
                                                    <ActionButton
                                                        label={t('userReporting.unlock')}
                                                        className="float-right header-item"
                                                        handleClick={() => {
                                                            this.setState({ unlockDialogVisible: true });
                                                        }}
                                                    />
                                                ) : null}
                                            </>
                                        )}
                                    </div>
                                )
                            }}
                            pageLinkSize={this.getPageLinkSize()}
                            lazy={this.props.lazy}
                            onPage={this.handlePage}
                            onSort={this.handleSort}
                            selectionMode={'checkbox'}
                            onSelectionChange={this.handleOnSelectionChange}
                            selection={this.state.selectedList}
                            selectAll={this.state.selectAll}
                            onSelectAllChange={this.handleOnSelectAllChange}
                            dataKey={this.dataKey}
                            expandedRows={this.state.expandedRows}
                            onRowToggle={this.handleOnRowToggle}
                            onRowExpand={this.handleOnRowExpand}
                            onRowCollapse={this.handleOnRowCollapse}
                            rowExpansionTemplate={this.rowExpansionTemplate}
                            selectionPageOnly={false}
                            tableStyle={{
                                minWidth: '1000px',
                                'table-layout': 'fixed'
                            }}
                        >
                            {this.props.rowExpansionTemplate ? <Column expander headerStyle={{width: '3em'}}></Column> : null}
                            {this.props.disableSelection === true || !this.props.selectionMode ? null : (
                                <Column selectionMode={this.props.selectionMode} headerStyle={{width: '3em'}}></Column>
                            )}
                            {dynamicColumns}
                        </DataTable>
                    </div>
                </DivContainer>
            </React.Fragment>
        );
    }

    enumTemplate(field, rowData) {
        if (rowData[field] && rowData[field].label) {
            return rowData[field].label;
        } else if (rowData[field]) {
            return rowData[field];
        }
        return '';
    }

    getIsColumnShouldBeDisabled(columnIndex) {
        const first = this.state.firstWeekColumns;//kolumny z czasem, pon. - niedz.
        const second = this.state.secondWeekColumns;//kolumny z czasem, pon. - niedz.
        const week = this.state.selectedWeek
        const includes = (week === 1) ? first?.includes(columnIndex) : second?.includes(columnIndex)
        //jesli wybrany 1 tydzien zablokuj te kolumny z 2, else zablokuj te z pierwszego
        const isSpecialCase = WeekViewDateUtils.isSpecialWeek(this.state.criteria.selectedDay)
        return isSpecialCase && includes
    }

    loadActivitiesForRow(rowData, rowIndex) {
        this.projectService
            .getTimeReportingActivities(rowData.project.id)
            .then(activities => {
                if (!activities.map((x) => x?.id).includes(rowData.activity?.id)) {
                    //usun aktywnosc jesli nie jest przypisana do wybranego projektu
                    rowData.activity = null
                }
                const data = this.state.activities.map;
                data[rowIndex] = activities;
                this.setState(({
                    activities: {
                        map: data
                    }
                }))
            }).catch((err) => {
                this.setState({
                    activities: {
                        map: {}
                    }
                })
                this.showErrorMessage(err.message);
            })
    }

    getProjectColumn(rowData, prop) {
        const { rowIndex } = prop;
        const { isActiveModel } = this.state;
        const { column } = prop;
        const columnIndex = column.props.columnIndex;


        const isDisabled = this.getIsAtLeastOneDayApproved(rowIndex) ||
            this.rowIsEmpty(rowIndex) //true jesli tydzien jest przechodni i obecny tydzien jest "pusty"
        return ( 
            isDisabled ? 
                <>
                    <td id={`project-${rowIndex}`} style={{
                        backgroundColor: 'inherit',
                        wordWrap: 'break-word',
                        wordBreak: 'break-word',
                        whiteSpace: 'normal',
                        overflowWrap: 'break-word',
                        color:'#5d5e5e'
                    }}>
                        <span>{`${rowData?.project.name}`}</span>
                    </td>
                </>
                :
            <Inplace
                    active={WeekViewUtils.getIsActive(rowIndex, columnIndex, isActiveModel)}
                    onToggle={(e) => {
                        this.onToggleFunction(rowIndex, columnIndex, isActiveModel)
                    }}
                    //disabled={isDisabled}
                    className='non-grayed-column' //kiedy pole jest zablokowane to nie wyszarzaj tekstu
                >
                    <InplaceDisplay>
                        <td id={`project-${rowIndex}`} style={{
                            backgroundColor: 'inherit',
                            wordWrap: 'break-word',
                            wordBreak: 'break-word',
                            whiteSpace: 'normal',
                            overflowWrap: 'break-word',
                        }}>
                            <span>{`${rowData?.project.name}`}</span>
                        </td>
                    </InplaceDisplay>
                    <InplaceContent>
                        <InputDropdownComponent
                            id={`project-input-${rowIndex}`}
                            name='project'
                            label='Projekt'
                            showLabel={false}
                            colClass='col-md-7'
                            value={rowData?.project}
                            validator={this.rowValidator}
                            options={this.state.projects}
                            onChange={(a, b, c, d) => {
                                const newList = [...this.state.list];
                                newList[rowIndex].project = c.target.value;
                                this.setState({ list: newList },
                                    () => {
                                        this.projectService
                                            .getTimeReportingActivities(rowData.project.id)
                                            .then(activities => {
                                                let activeFields = this.state.isActiveModel.map ? this.state.isActiveModel?.map : {};
                                                if (!activities.map((x) => x?.id).includes(rowData.activity?.id)) {
                                                    //usun aktywnosc jesli nie jest przypisana do wybranego projektu
                                                    rowData.activity = null
                                                    const activityColumnIndex = 2;
                                                    activeFields[[rowIndex, activityColumnIndex]] = true; //usuwana jest aktywnosc ktorej nie ma w projekcie, 
                                                    //user musi ustawic aktywnosc z projektu, pole zostaje "otwarte" do edycji
                                                }
                                                const data = this.state.activities.map;
                                                data[rowIndex] = activities;
                                                this.setState(({
                                                    isActiveModel:{
                                                        map: activeFields
                                                    },
                                                    activities: {
                                                        map: data
                                                    }
                                                }))
                                            }).catch((err) => {
                                                this.setState({
                                                    activities: {
                                                        map: {}
                                                    }
                                                })
                                                this.showErrorMessage(t('userReporting.activityError'));
                                            })
                                    });
                            }}
                            style={{
                                height: '35px',
                                maxWidth: '100%',
                                minWidth: '80px',
                                width: '100%',
                                boxSizing: 'border-box'
                            }}
                            className='custom-dropdown'
                            viewMode={'NEW'}
                            optionLabel='name'
                            dataKey='id'
                            validators='required'
                            placeholder={t('userReporting.project')}
                            filter
                            filterBy='name'
                            insideTable
                        />
                    </InplaceContent>
                </Inplace>
        );
    }    

    rowIsEmpty(rowIndex) {
        //kiedy nie ma rekordow na "obecnym" tygodniu, a na drugim tak,
        // to nie powinno byc mozliwosci edycji projektu/aktywnosci
        if (WeekViewDateUtils.isSpecialWeek(this.state.criteria.selectedDay)) {
            return this.getCurrentWeekEventsForRow(rowIndex).map(x=>x?.id).filter(x=>x).length === 0
        }
    }

    getActivityColumn(rowData, prop) {
        const { isActiveModel } = this.state;
        const { rowIndex } = prop;
        const { column } = prop;
        const columnIndex = column.props.columnIndex;

        const isDisabled = this.getIsAtLeastOneDayApproved(rowIndex) ||
            this.rowIsEmpty(rowIndex) //true jesli tydzien jest przechodni i obecny tydzien jest "pusty"
        return (
            isDisabled ?
                <>
                    <td
                        style={{
                            backgroundColor: 'inherit',
                            wordWrap: 'break-word',
                            wordBreak: 'break-word',
                            whiteSpace: 'normal',
                            overflowWrap: 'break-word',
                            color:'#5d5e5e'
                        }}>
                        <span className=''>
                            {rowData?.activity?.name ? `${rowData?.activity.name}` : ''}
                        </span>
                    </td>
                </>
            :
            <Inplace
                active={WeekViewUtils.getIsActive(rowIndex, columnIndex, isActiveModel)}
                onToggle={(e) => {
                    if (!isDisabled) {
                        if (this.state.activities.map[rowIndex] === undefined) {
                            this.loadActivitiesForRow(rowData, rowIndex)
                        }
                        this.onToggleFunction(rowIndex, columnIndex, isActiveModel)
                    }
                }}
                unstyled
                //disabled={isDisabled}
                className='non-grayed-column' //kiedy pole jest zablokowane to nie wyszarzaj tekstu
                >

                <InplaceDisplay>
                    <td
                        style={{
                            backgroundColor: 'inherit',
                            wordWrap: 'break-word',
                            wordBreak: 'break-word',
                            whiteSpace: 'normal',
                            overflowWrap: 'break-word',
                        }}>
                        <span className=''>
                            {rowData?.activity?.name ? `${rowData?.activity.name}` : ''}
                        </span>
                    </td>
                </InplaceDisplay>
                <InplaceContent
                style={{
                    width:'20px'
                }}
                >
                <InputDropdownComponent
                        id='activity'
                        name='activity'
                        colClass='col-lg-2 col-sm-2 col-md-2'
                        label='Aktywność'
                        showLabel={false}
                        value={rowData?.activity}
                        validator={this.rowValidator}
                        options={this.state.activities.map[rowIndex]}
                        onChange={(a,b,c,d) => {
                            const newList = this.state.list;
                            newList[rowIndex].activity = c.target.value;
                            this.setState({
                                list: newList
                            })
                        }}
                        style={{
                                height: '35px',
                                maxWidth: '100%',
                                width: '100%',
                                boxSizing: 'border-box'
                        }}
                        viewMode={'NEW'}
                        optionLabel='name'
                        className='custom-dropdown'
                        dataKey='id'
                        validators='required'
                        placeholder={t('userReporting.activity')}
                        filter
                        filterBy='name'
                        insideTable
                    />
                </InplaceContent>
            </Inplace>
        );
    }

    getUserTimeColumn(day, rowData, props) {
        if (rowData.events[day] === null) {
            rowData.events[day] = [{
                timeFrom: null,
                timeTo: null
            }];
            return rowData.events[day].map((event, index) => {
                return this.getUserTimeColumnIfArray(day, event, 0, props);
            })
        } else if (Array.isArray(rowData.events[day])) {
            return rowData.events[day].map((event, index) => {
                return this.getUserTimeColumnIfArray(day, event, index, props);
            })
        }
    }


    getUserTimeColumnIfArray(day, event, index, props) {
        const { isActiveModel } = this.state;
        const { rowIndex, column } = props;
        const startEndRequired = this.isStartEndDateRequired();
        const columnIndex = column.props.columnIndex;

        //flaga czy kolumna jest w tygodniu 'przechodnim' lub rekord jest juz zaakceptowany przez PM'a/usera
        const isDisabled = this.getIsColumnShouldBeDisabled(columnIndex + 1) ||
            (this.state.list[rowIndex]?.events[day][index]?.acceptLevel === Constants.PM_APPROVED_LEVEL ||
                this.state.list[rowIndex]?.events[day][index]?.acceptLevel === Constants.TO_APPROVE_BY_PM_LEVEL);


        const renderCommentIcon = () => {
            return (
                <ActionLink
                    iconName='pi-comment'
                    iconPrefix='pi'
                    iconSide='left'
                    iconSize='icon-medium'
                    rendered={(
                        this.state.list[rowIndex]?.events[day][index].userTime ||
                        (this.state.list[rowIndex]?.events[day][index].timeFrom &&
                            this.state.list[rowIndex]?.events[day][index].timeTo)
                    ) && this.state.list[rowIndex]?.events[day][index]?.comment?.length >= 1
                        && !WeekViewUtils.getIsActive(rowIndex, columnIndex, isActiveModel)}
                    color='black'
                    key={'comment-icon'}
                    tooltipContent={this.state.list[rowIndex]?.events[day][index]?.comment}
                    tooltipTarget={WeekViewUtils.getIsActive(rowIndex, columnIndex, isActiveModel) ? null : '.tooltip-target'}
                />
            );
        };
        const display = this.getValidTimeRenderRule(day).renderDisplayValue(event, index)

        const renderIfDisabled = () => {
            //wyswietl czas w formie tekstowej

            return (
                <td style={{ backgroundColor: 'inherit', color: '#5d5e5e' }}>
                    <div style={{ display: 'flex', justifyContent: 'start', marginLeft: '10px' }}>
                        <span style={{ marginTop: '10%' }}>
                            {display}
                        </span>
                        <div style={{ marginLeft: '5px' }}>
                            {renderCommentIcon()}
                        </div>
                    </div>
                </td>
            );
        };

        const renderInplace = () => {
            //wyswietl komponent inplace


            const renderTime = () => {
                //render czasu w wierszu na podstawie obecnych ustawień 
                return this.getValidTimeRenderRule(day).renderTimeForRow(rowIndex, columnIndex, day, index, isActiveModel, event)
            }

            return (
                <div id={`time-report-inplace-${day}`}
                 style={{
                    display: 'flex',
                    justifyContent: 'center',
                    marginLeft: this.state.list[rowIndex]?.events[day][index].userTime &&
                        this.state.list[rowIndex]?.events[day][index]?.comment?.length >= 1 &&
                        !WeekViewUtils.getIsActive(rowIndex, columnIndex, isActiveModel)
                        ? "10px" : "0px"
                }}>
                    <Inplace
                        active={WeekViewUtils.getIsActive(rowIndex, columnIndex, isActiveModel)}
                        onToggle={(e) => {
                            if (!isDisabled) {
                                this.onToggleFunction(rowIndex, columnIndex, isActiveModel);
                            }
                        }}
                    >
                        <InplaceDisplay>
                            <td style={{ backgroundColor: 'inherit' }}>
                                <div style={{ display: 'flex', justifyContent: 'start', marginLeft: '10px' }}>
                                    <span style={{ marginTop: '10%' }}>
                                        {display}
                                    </span>
                                    <div>
                                        {renderCommentIcon()}
                                    </div>
                                </div>
                            </td>
                        </InplaceDisplay>
                        <InplaceContent>
                            {renderTime()}
                        </InplaceContent>
                    </Inplace>
                </div>
            );
        };



        return (
            isDisabled ? renderIfDisabled() : renderInplace()
        );
    }


    renderUserTimeWithCreativeTimeForRow(rowIndex, columnIndex, day, index, isActiveModel, event) {

        const renderIconsForUserTime = () => {
            return <div className='col' style={{ maxWidth: '10px' }}>
                <div className='col'>
                    {this.state.list[rowIndex]?.events[day][index].userTime &&
                        this.state.list[rowIndex]?.events[day][index]?.comment?.length >= 1 ?
                        <ActionLink
                            iconName='pi-comment'
                            iconPrefix='pi'
                            iconSide='left'
                            iconSize='icon-medium'
                            color='black'
                            rendered={true}
                            key={'comment-button'}
                            tooltipContent={this.state.list[rowIndex]?.events[day][index]?.comment}
                            tooltipTarget={'.tooltip-target'}
                        />
                        :
                        null}
                    {WeekViewUtils.getIsActive(rowIndex, columnIndex, isActiveModel) &&
                        this.state.list[rowIndex].events[day][index].id !== undefined ?
                            <ActionLink
                                id={`delete-record-button-${rowIndex}-${columnIndex}`}
                                iconName='pi-times-circle'
                                iconPrefix='pi'
                                iconSize='icon-medium'
                                handleClick={(e) => {
                                    const list = [...this.state.list];
                                    list[rowIndex].events[day][index] = {
                                        ...event,
                                        timeTo: null,
                                        timeFrom: null
                                    }
                                    this.handleDeleteRecord(list[rowIndex].events[day][index].id, rowIndex);
                                }}
                                rendered={true}
                                color='black'
                                key={'delete-button'}
                            />
                        : null}
                </div>
            </div>
        }

        const style = {
            minWidth: '30px',
            maxWidth:
                this.state.list[rowIndex].events[day][index].id !== undefined ||
                    this.state.list[rowIndex].events[day][index].comment
                    ? '40px'
                    : '50px',
            boxSizing: 'border-box',
        };

        const isDisabled = this.getIsColumnShouldBeDisabled(index + 4);
        return <div className='row'>
            <div style={{ '--bs-gutter-x': '0.2rem', maxWidth: '90px' }} className='row'>
                <div className='col'>
                    <InputCalendarComponent
                        id={isDisabled ? `disabled-userTime-${index}-${columnIndex}` : `userTime-${index}-${columnIndex}`}
                        name={'userTime'}
                        value={this.state.list[rowIndex]?.events[day][index].userTime}
                        validator={this.rowValidator}
                        onChange={(a, b, c, d) => {
                            const list = [...this.state.list];
                            list[rowIndex].events[day][index].userTime = c.target.value;
                            this.setState({ list });
                        }}
                        label={t('userReporting.workTime')}
                        showLabel={false}
                        insideTable
                        showTime
                        validateViewMode={true}
                        dateFormatMoment="HH:mm"
                        timeOnly
                        validators={`more_than_zero_week_row:${this.state.list[rowIndex]?.events[day][index].userTime}|creative_time_validation:${index},${day},${rowIndex}`}
                        placeholder="HH:mm"
                        className="user-reporting-time-style"
                        showSeconds={false}
                        showIcon={false}
                        icon={() => <i className="clock" />}
                        readOnlyInput={false}
                        propCustomValue={true}
                        viewMode={'NEW'}
                        mask="99:99"
                        disabled={isDisabled ? true : false}
                        style={style}
                        validateViewStyle={{
                            width: '20px',
                            marginLeft: '8px',
                            textAlign: 'right'
                        }}
                        customTimePicker={(e) => {
                            return (
                                <InputTextareaComponent
                                    label={t('userReporting.comment')}
                                    value={this.state.list[rowIndex].events[day][index].comment}
                                    showLabel={true}
                                    insideTable
                                    rendered={true}
                                    onChange={(a, b, c, d) => {
                                        const list = [...this.state.list];
                                        list[rowIndex].events[day][index].comment = c.target.value;
                                        this.setState((prev) => ({
                                            list: list
                                        }));
                                    }}
                                    maxlength={500}
                                    viewMode={'NEW'}
                                    autoResize
                                    className='report-week-comment'
                                />
                            );
                        }}

                        onInputClick={(id) => {
                            const input = document.getElementById(id)
                            input.focus();
                            input.setSelectionRange(0, 0);
                        }}
                    />
                </div>
                <div className='col' style={{}}>
                    <InputCalendarComponent
                        id={isDisabled ? `disabled-creativeTime-${index}-${columnIndex}` : `creativeTime-${index}-${columnIndex}`}
                        name={'creativeTime'}
                        value={this.state.list[rowIndex]?.events[day][index].creativeTime}
                        validator={this.rowValidator}
                        onChange={(a, b, c, d) => {
                            const list = [...this.state.list];
                            list[rowIndex].events[day][index].creativeTime = c.target.value;
                            this.setState({ list });
                        }}
                        label={t('userReporting.creativeTime')}
                        showLabel={false}
                        insideTable
                        showTime
                        validateViewMode={false}
                        dateFormatMoment="HH:mm"
                        timeOnly
                        placeholder="HH:mm"
                        className="week-view-creative-time-wrapper"
                        showSeconds={false}
                        validators={`more_than_zero_week_row:${this.state.list[rowIndex]?.events[day][index].creativeTime}|creative_time_validation:${index},${day},${rowIndex}`}
                        showIcon={false}
                        icon={() => <i className="clock" />}
                        readOnlyInput={false}
                        propCustomValue={true}
                        viewMode={'NEW'}
                        mask="99:99"
                        disabled={isDisabled ? true : false}
                        style={style}
                        customTimePicker={() => { }}
                        onInputClick={(id) => {
                            const input = document.getElementById(id)
                            input.focus();
                            input.setSelectionRange(0, 0);
                        }}
                    />
                </div>
                {renderIconsForUserTime()}
            </div>
        </div>
    }


    renderUserTimeForRow(rowIndex, columnIndex, day, index, isActiveModel, event) {
        // inputy z czasem dla wierszy w tabeli

        const renderIconsForUserTime = () => {
            return <div className='col' style={{
                maxWidth: '10px'
            }}>
                <div
                    className='col'>
                    <ActionLink
                        iconName='pi-comment'
                        iconPrefix='pi'
                        iconSide='left'
                        iconSize='icon-medium'
                        rendered={this.state.list[rowIndex]?.events[day][index].userTime
                            && this.state.list[rowIndex]?.events[day][index]?.comment?.length >= 1 ? true : false}
                        color='black'
                        key={'delete-button'}
                        tooltipContent={this.state.list[rowIndex]?.events[day][index]?.comment}
                        tooltipTarget={'.tooltip-target'}
                    />
                    <ActionLink
                        id={`delete-record-button-${rowIndex}-${columnIndex}`}
                        iconName='pi-times-circle'
                        iconPrefix='pi'
                        iconSize='icon-medium'
                        rendered={
                            WeekViewUtils.getIsActive(rowIndex, columnIndex, isActiveModel)
                            && this.state.list[rowIndex].events[day][index].id !== undefined
                        }
                        handleClick={(e) => {
                            const list = [...this.state.list];
                            list[rowIndex].events[day][index] = {
                                ...event,
                                timeTo: null,
                                timeFrom: null
                            }
                            this.handleDeleteRecord(list[rowIndex].events[day][index].id, rowIndex);
                        }}
                        color='black'
                        key={'delete-button'}
                    />
                </div>
            </div>
        }

        const style = {
            minWidth: '30px',
            maxWidth: this.state.list[rowIndex].events[day][index].id !== undefined
                || this.state.list[rowIndex].events[day][index].comment ? '40px' : '50px',
            boxSizing: 'border-box',
        }



        return <div style={{
            display: 'flex',
            justifyContent: 'start'
        }}>
            <InputCalendarComponent
                id={`userTime-${rowIndex}-${columnIndex}`}
                name={'userTime'}
                value={this.state.list[rowIndex]?.events[day][index].userTime}
                onChange={(a, b, c, d) => {
                    const list = [...this.state.list];
                    list[rowIndex].events[day][index].userTime = c.target.value;
                    this.setState(() => ({
                        list: list
                    }));
                }}
                viewMode={'NEW'}
                showLabel={false}
                insideTable
                showTime
                validator={this.rowValidator}
                validators={`more_than_zero_week_row:${this.state.list[rowIndex]?.events[day][index].userTime}`}
                dateFormatMoment='HH:mm'
                timeOnly
                validateViewMode={true}
                showSeconds={false}
                showIcon={false}
                icon={() => <i className='clock' />}
                readOnlyInput={false}
                propCustomValue={true}
                className={'user-reporting-time-style'}
                placeholder=''
                mask='99:99'
                style={{
                    minWidth: '30px',
                    maxWidth: this.state.list[rowIndex].events[day][index].id !== undefined
                        || this.state.list[rowIndex].events[day][index].comment ? '40px' : '50px',
                    boxSizing: 'border-box',
                }}
                customTimePicker={(e) => {
                    return (
                        <InputTextareaComponent
                            label={t('userReporting.comment')}
                            value={this.state.list[rowIndex].events[day][index].comment}
                            showLabel={true}
                            insideTable
                            rendered={true}
                            onChange={(a, b, c, d) => {
                                const list = [...this.state.list];
                                list[rowIndex].events[day][index].comment = c.target.value;
                                this.setState((prev) => ({
                                    list: list
                                }));
                            }}
                            maxlength={500}
                            viewMode={'NEW'}
                            autoResize
                            className='report-week-comment'
                        />
                    );
                }}
                onInputClick={(id) => {
                    const input = document.getElementById(id)
                    input.focus();
                    input.setSelectionRange(0, 0);
                }}
            />
            {renderIconsForUserTime()}
        </div>
    }


    renderFromToUserTimeForRow = (rowIndex, columnIndex, day, index, isActiveModel, event) => {
        //inputy z czasem od do dla wierszy w tabeli

        const renderIcons = (rowIndex, columnIndex, day, index, isActiveModel, event) => {
            let icons = [
                {
                    rendered: this.state.list[rowIndex]?.events[day][index].timeFrom &&
                        this.state.list[rowIndex]?.events[day][index].timeTo &&
                        this.state.list[rowIndex]?.events[day][index]?.comment?.length >= 1,
                    iconClass: 'pi pi-comment',
                    style: {
                        width: "20px",
                        fontSize: '15px'
                    },
                    onClick: () => { }
                },
                {
                    id: `delete-record-button-${rowIndex}-${columnIndex}`,
                    rendered: WeekViewUtils.getIsActive(rowIndex, columnIndex, isActiveModel) &&
                        this.state.list[rowIndex]?.events[day][index]?.id !== undefined,
                    iconClass: 'pi pi-times-circle',
                    style: {
                        width: "20px",
                        fontSize: '15px'
                    },
                    onClick: () => {
                        const list = [...this.state.list];
                        list[rowIndex].events[day][index] = {
                            ...event,
                            timeTo: null,
                            timeFrom: null
                        };
                        this.handleDeleteRecord(list[rowIndex].events[day][index].id, rowIndex);
                    }
                }
            ];

            return (
                <div className='row'
                    style={{
                        marginLeft: '35px',
                        position: 'absolute',
                        display: 'flex',
                        flexDirection: 'column',
                        alignItems: 'center',
                        justifyContent: 'center',
                    }}>
                    {icons.map((icon, idx) =>
                        icon.rendered ? (
                            <i key={idx}
                                id={icon?.id}
                                className={icon.iconClass}
                                style={icon.style}
                                onClick={icon.onClick}
                            />
                        ) : null
                    )}
                </div>
            );
        }

        return <div style={{ '--bs-gutter-x': '0.2rem' }} className='row'>
            <div className='col'>
                <InputCalendarComponent
                    id={`time-from-input-${rowIndex}-${day}-${index}-${columnIndex}`}
                    name={'timeFrom'}
                    value={this.state.list[rowIndex]?.events[day][index].timeFrom}
                    onChange={(a, b, c, d) => {
                        const list = [...this.state.list];
                        list[rowIndex].events[day][index].timeFrom = c.target.value;
                        this.setState(() => ({
                            list: list
                        }));
                    }}
                    viewMode={'NEW'}
                    showLabel={false}
                    insideTable
                    showTime
                    validator={this.rowValidator}
                    validators={`from_less_than_to:${index},${day},${rowIndex}`}
                    dateFormatMoment='HH:mm'
                    timeOnly
                    validateViewMode={true}
                    validateViewStyle={{
                        width: '20px',
                        marginLeft: '8px',
                        textAlign: 'right'
                    }}
                    showSeconds={false}
                    showIcon={false}
                    icon={() => <i className='clock' />}
                    readOnlyInput={false}
                    propCustomValue={true}
                    className={'user-reporting-from-to-time-style'}
                    placeholder=''
                    mask='99:99'
                    style={{
                        maxWidth: '40px',
                        boxSizing: 'border-box',
                    }}
                    customTimePicker={(e) => {
                        return (
                            <InputTextareaComponent
                                label={t('userReporting.comment')}
                                value={this.state.list[rowIndex].events[day][index].comment}
                                showLabel={true}
                                insideTable
                                rendered={true}
                                onChange={(a, b, c, d) => {
                                    const list = [...this.state.list];
                                    list[rowIndex].events[day][index].comment = c.target.value;
                                    this.setState((prev) => ({
                                        list: list
                                    }));
                                }}
                                maxlength={500}
                                viewMode={'NEW'}
                                autoResize
                                className='report-week-comment'
                            />
                        );
                    }}
                    onInputClick={(id) => {
                        const input = document.getElementById(id)
                        input.focus();
                        input.setSelectionRange(0, 0);
                    }}
                />
            </div>
            <div className='col'>
                <div style={{
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'flex-start'
                }}>
                    <InputCalendarComponent
                        id={`time-to-input-${rowIndex}-${day}-${index}-${columnIndex}`}
                        name={'timeTo'}
                        value={this.state.list[rowIndex]?.events[day][index].timeTo}
                        onChange={(a, b, c, d) => {
                            const list = [...this.state.list];
                            list[rowIndex].events[day][index].timeTo = c.target.value;
                            this.setState(() => ({
                                list: list
                            }));
                        }}
                        viewMode={'NEW'}
                        showLabel={false}
                        insideTable
                        showTime
                        validator={this.rowValidator}
                        validators={`from_less_than_to:${index},${day},${rowIndex}`}
                        dateFormatMoment='HH:mm'
                        timeOnly
                        validateViewMode={false}
                        showSeconds={false}
                        showIcon={false}
                        icon={() => <i className='clock' />}
                        readOnlyInput={false}
                        propCustomValue={true}
                        className={'user-reporting-from-to-time-style'}
                        placeholder=''
                        mask='99:99'
                        style={{
                            maxWidth: '40px',
                            boxSizing: 'border-box',
                        }}
                        customTimePicker={(e) => {
                        }}
                        onInputClick={(id) => {
                            const input = document.getElementById(id)
                            input.focus();
                            input.setSelectionRange(0, 0);
                        }}
                    />
                    {renderIcons(rowIndex, columnIndex, day, index, isActiveModel, event)}
                </div>
            </div>
        </div>
    }

    handleDeleteRecord(eventIndex, rowIndex) {
        //this.showErrorMessage('elo elo ')
        let data = this.state.isActiveModel.map;
        for (const [key, value] of Object.entries(data)) {
            const arr = key.split(',').map(Number);
            if (arr[0] === rowIndex) {
                data[[arr[0], arr[1]]] = false; //"zamknij" wszystkie inplace z danego wiersza
            }
        }
        this.setState({
            loading: false,
            isActiveModel: {
                map: data
            }
        }, () => {
            this.service
                .delete(eventIndex)
                .then((x) => {
                    this.refreshTable(rowIndex)
                })
                .catch((err) => {
                    this.showErrorMessage(t('userReporting.deleteError'))
                });
        });
    }

    cancelRowEdit(rowIndex) {
        const data = this.getClosedInplaceComponentsMapForRow(rowIndex);
        this.setState({
            isActiveModel: {
                map: data
            }
        })
    }

    getIsAtLeastOneDayApproved(rowIndex) {
        //true jesli chociaz jeden event jest juz zaakceptowany przez PM/usera
        if (WeekViewDateUtils.isSpecialWeek(this.state.criteria.selectedDay)) {
            return this.getCurrentWeekEventsForRow(rowIndex)?.flatMap(x => x?.acceptLevel)
                .filter(x => x && x === Constants.PM_APPROVED_LEVEL || x === Constants.TO_APPROVE_BY_PM_LEVEL)
                .length > 0
        } else {
            return this.state.list[rowIndex].events?.flatMap(x => x).map(x => x?.acceptLevel)
                .filter(x => x === Constants.PM_APPROVED_LEVEL || x === Constants.TO_APPROVE_BY_PM_LEVEL)
                .length > 0
        }
    }
    
    showConfirmDeleteActivityDialog(rowData, rowIndex) {
        const eventsToDelete = rowData.events.flatMap((x) => x).map((x) => x.id).filter((x) => x);
        this.setState({
            showConfirmDeleteActivityDialog: true,
            eventsToDelete: eventsToDelete,
            rowToDelete: rowIndex
        });
    }

    getActionsColumn(rowData, props) {
        const { rowIndex } = props;

        const isRowActive = this.isRowActive(rowIndex);
        let isAtLeastOneDayApproved = false;
        let atLeastOneRecordToDeleteExists = false;

        if (WeekViewDateUtils.isSpecialWeek(this.state.criteria.selectedDay)) {
            isAtLeastOneDayApproved = this.getIsAtLeastOneDayApproved(rowIndex)
            atLeastOneRecordToDeleteExists = this.getCurrentWeekEventsForRow(rowIndex)?.length > 0
        } else {
            isAtLeastOneDayApproved = this.getIsAtLeastOneDayApproved(rowIndex)
            atLeastOneRecordToDeleteExists = this.state.list[rowIndex].events.flatMap(x => x).map(x => x.id).filter(x => x).length > 0
        }

        return (
            <div style={{ display: 'flex', justifyContent: 'start', maxWidth: '60px' }}>
                {isRowActive ? (
                    <>
                        <ActionLink
                            id='update-row-button'
                            iconName='pi pi-check'
                            iconPrefix='pi'
                            iconSide='left'
                            iconSize='icon-medium'
                            rendered={true}
                            color='black'
                            handleClick={(e) => {
                                this.handleEditActivity(rowData, rowIndex)
                            }}
                            classN
                            ame='edit-blue-link'
                            key={'delete-button'}
                        />
                        <ActionLink
                            iconName='mdi mdi-cancel'
                            iconSize='icon-medium'
                            rendered={true}
                            handleClick={(e) => {
                                this.cancelRowEdit(rowIndex)
                                this.refreshTable()
                            }}
                            color='black'
                            classN
                            ame='edit-blue-link'
                            key={'delete-button'}
                        />
                    </>
                ) :

                //zablokowanie usuniecia wiersza kiedy user/pm jus cos zatwierdzil
                    isAtLeastOneDayApproved ? null :
                        //wyswietlenie tylko wtedy kiedy jest jakis event do usuniecia w wierszu
                        atLeastOneRecordToDeleteExists ?
                            (<ActionLink
                                id={`delete-row-button-${rowIndex}`}
                                iconName='mdi mdi-delete'
                                iconSize='icon-medium'
                                rendered={true}
                                handleClick={(e) => {
                                    this.showConfirmDeleteActivityDialog(rowData, rowIndex)
                                }}
                                color='black'
                                classN
                                ame='edit-blue-link'
                                key={'delete-button'}
                            />) : null
                }
            </div>
        )
    }

    getClientColumn(rowData) {
        const clientName = rowData?.client?.name;
        return <span style={{
                color: '#5d5e5e'
            }}>
                {clientName}
            </span>
    }

    prepareColumns() {
        const flag = this.isStartEndDateRequired()

        const atLeastOnePermanentContract = this.state.contractsForDays.filter(x => x === 'PERNAMENT').length >= 1;
        const featureEnabled = this.authService.getProfile().featureCreativeWorkReportingEnabled

        return [
        {
            field: 'client.name',
            header: t('userReporting.client'),
            sortable: false,
            sortField: 'emailType',
            body: this.getClientColumn.bind(this),
            width: (atLeastOnePermanentContract && featureEnabled) || flag ? '65px' : '95px'

        },
        {
            field: 'project.name',
            header: t('userReporting.project'),
            sortable: false,
            sortField: 'description',
            body: this.getProjectColumn.bind(this),
            width: (atLeastOnePermanentContract && featureEnabled) || flag  ? '115px' : '180px'
        },
        {
            field: 'activity.name',
            header: t('userReporting.activity'),
            sortable: false,
            sortField: 'activity',
            body: this.getActivityColumn.bind(this),
            width: (atLeastOnePermanentContract && featureEnabled) || flag  ? '95px' : '140px'
        },
        {
            field: 'userTime',
            sortable: false,
            body: this.getUserTimeColumn.bind(this, 0),
            width: this.isCreativeTimeColumnRequired(0) || flag ? '100px' : '80px',
            className: 'column-header-center'
        },
        {
            field: 'userTime',
            sortable: false,
            body: this.getUserTimeColumn.bind(this, 1),
            width: this.isCreativeTimeColumnRequired(1) || flag ? '100px' : '80px',
            className: 'column-header-center'
        },
        {
            field: 'userTime',
            sortable: false,
            body: this.getUserTimeColumn.bind(this, 2),
            width: this.isCreativeTimeColumnRequired(2) || flag ? '100px' : '80px',
            className: 'column-header-center'
        },
        {
            field: 'userTime',
            sortable: false,
            body: this.getUserTimeColumn.bind(this, 3),
            width: this.isCreativeTimeColumnRequired(3) || flag ? '100px' : '80px',
            className: 'column-header-center'
        },
        {
            field: 'userTime',
            sortable: false,
            body: this.getUserTimeColumn.bind(this, 4),
            width:this.isCreativeTimeColumnRequired(4) || flag ? '100px' : '80px',
            className: 'column-header-center'

        },
        {
            field: 'userTime',
            sortable: false,
            body: this.getUserTimeColumn.bind(this, 5),
            width: this.isCreativeTimeColumnRequired(5) || flag ? '100px' : '80px',
            className: 'column-header-center'
        },
        {
            field: 'userTime',
            sortable: false,
            body: this.getUserTimeColumn.bind(this, 6),
            width:this.isCreativeTimeColumnRequired(6) ||  flag ? '100px' : '80px',
            className: 'column-header-center'
        },
        {
            field: 'summary',
            header: '',
            sortable: false,
            body: this.getRowSummary.bind(this),
            style: (atLeastOnePermanentContract && featureEnabled)
                ? {
                    width: '60px',
                    maxWidth: '60px',
                    textAlign: 'left'
                }
                : { width: '50px' }
        },
        {
            field: '',
            header: '',
            sortable: false,
            body: this.getActionsColumn.bind(this),
            width: '70px'
        }
        ];
    }

    afterObjectUpdate() {
        this.readMessage();
        this.refreshTable();
        this.unblockUi();
    }


    getClosedInplaceComponentsMapForRow(rowIndex) {
        let data = this.state.isActiveModel.map;
        for (const [key, value] of Object.entries(data)) {
            const arr = key.split(',').map(Number);
            if (arr[0] === rowIndex) {
                data[[arr[0], arr[1]]] = false; //"zamknij" wszystkie inplace z danego wiersza
            }
        }
        return data;
    }

    decreaseSelectedWeek(isSpecialCase) {
        const { criteria } = this.state;
        const isPreviousWeekIsSpecial = (newDate) => {
            return !isSpecialCase && WeekViewDateUtils.isSpecialWeek(newDate)
        }
        const newDate = isSpecialCase ? moment(criteria.selectedDay).subtract(7, 'day') : criteria.selectedDay.subtract(7, 'day');
        const handleWeekBackwards = () => {
            this.setState((prevState) => ({
                selectedWeek: 1,
                criteria: {
                    ...prevState.criteria,
                    selectedDay: newDate
                },
                userDays: []
            }), this.refreshTable())
        }

        const handleSpecialWeekCurrent = () => {
            this.setState((prevState) => ({
                selectedWeek: 0,
                criteria: {
                    ...prevState.criteria,
                    selectedDay: newDate.add(7, 'day')
                },
                userDays: []
            }), this.refreshTable()
            )
        }
        const handleDefault = () => {
            this.setState({
                criteria: { ...criteria, selectedDay: newDate },
                userDays: []
            }, this.refreshTable);
        }

        if (isPreviousWeekIsSpecial(newDate)) { //user sie cofa i poprzedni tydzien jest "przechodni". Ustawia jedynke
            handleWeekBackwards();
            return;
        } else if (isSpecialCase && this.state.selectedWeek === 1) { //obecny jest "przechodni"
            handleSpecialWeekCurrent()
            return;
        } else {
            handleDefault()
        }
    }

   
    increaseSelectedWeek(isSpecialCase) {
        const { criteria, selectedWeek } = this.state;
        const newDate = isSpecialCase ? moment(criteria.selectedDay).add(7, 'day') : criteria.selectedDay.add(7, 'day');

        const handleSpecialWeekForward = () => {
            this.setState({
                selectedWeek: 0,
                criteria: { ...criteria, selectedDay: newDate },
                userDays: []
            }, this.refreshTable);
        };
    
        const handleSpecialWeekCurrent = () => {
            this.setState({
                selectedWeek: 1,
                criteria: { ...criteria, selectedDay: newDate.subtract(7, 'day') },
                userDays: []
            }, this.refreshTable);
        };
    
        const handleDefault = () => {
            this.setState({
                criteria: { ...criteria, selectedDay: newDate },
                userDays: []
            }, this.refreshTable);
        };
    
        if (!isSpecialCase && WeekViewDateUtils.isSpecialWeek(newDate)) { //jesli kolejny tydzien jest "przechodni" 
            handleSpecialWeekForward();
            return;
        } else if (isSpecialCase && selectedWeek === 0) { //jesli obecnie wybrany jest "przechodni"
            handleSpecialWeekCurrent();
            return;
        } else { 
            handleDefault();
        }
    }
    
    refreshTable() {
        this.getList();
        if(this.state.list.length === 0){
            this.setState({
                activeFields:{
                    map: {}
                }
            });
        }
        if (WeekViewDateUtils.isSpecialWeek(this.state.criteria.selectedDay)) {
            this.closeInplacesIfSpecialCase();
        }
    }

    renderHeaderDetails() {
        const { criteria } = this.state;
        const weekRange = WeekViewDateUtils.getWeekRange(criteria.selectedDay);
        const isSpecialCase = weekRange[0].month() !== weekRange[1].month();
        return (
            <div style={{
                display:'flex',
                justifyContent: 'start'
            }}>
                <i className="timelineHeaderIcon mdi mdi-chevron-left icon-large-plus " style={{ marginRight: '14px', color: '#9d9d9e', cursor: 'pointer', fontSize: '40px' }}
                     onClick={() => {
                         if (this.isDirty()) { 
                             this.setState({ //wywal komunikat jesli dirty
                                dialogVisibile: true
                            })
                         }else{ //else idz do tylu
                            this.decreaseSelectedWeek(isSpecialCase)
                         }
                    }}
                />
                <i className="timelineHeaderIcon mdi mdi-chevron-right icon-large-plus " style={{ marginRight: '14px', color: '#9d9d9e', cursor: 'pointer', fontSize: '40px' }}
                    onClick={() => {
                        if (this.isDirty()) { //wywal komunikat jesli dirty
                            this.setState({
                                dialogVisibile: true
                            })
                        }else{ //else idz do przodu
                            this.increaseSelectedWeek(isSpecialCase)
                        }
                    }}
                />
                <span style={{
                    fontSize: '30px',
                    paddingTop: '17px'
                }}>
                   {WeekFormatter(criteria.selectedDay, isSpecialCase, WeekViewDateUtils.getWeekRange(criteria.selectedDay), this.state.selectedWeek)}
                </span>
            </div>
        );
    }
    
    getApproveReportedDayDialog() {
        return (
            <YesNoDialog
                visible={this.state.approveDialogVisible}
                header={t('userReporting.acceptHeaderWeek')}
                name='visible'
                onChange={(type, x, target) => {
                    if (target.value) {
                        this.handleApprove();
                        this.setState({ approveDialogVisible: false })
                    } else {
                        this.setState({ approveDialogVisible: false })
                    }
                }}
                onHide={() => this.setState({ approveDialogVisible: false })}
            >
                {t('userReporting.week.confirmMessage')}
            </YesNoDialog>
        );
    }

    getUnlockReportedDayDialog() {
        return (
            <YesNoDialog
                visible={this.state.unlockDialogVisible}
                header={t('userReporting.unlockHeaderWeek')}
                name='visible'
                onChange={(type, x, target) => {
                    if (target.value) {
                        this.handleUnlockReportedDay();
                        this.setState({ unlockDialogVisible: false })
                    } else {
                        this.setState({ unlockDialogVisible: false })
                    }
                }}
                onHide={() => this.setState({ unlockDialogVisible: false })}
            >
                {t('userReporting.week.unblockMessage')}
                </YesNoDialog>
        );
    }
    handleApprove() {
        //TODO       
        let uniqueUserDayIds = []
        if (WeekViewDateUtils.isSpecialWeek(this.state.criteria.selectedDay)) {
            uniqueUserDayIds = [...new Set(this.getCurrentWeekEvents().map(x => x.userDayId).filter((x) => x !== undefined))]
        } else {
            uniqueUserDayIds = [...new Set(this.state.list.flatMap((x) => x.events).flatMap(x => x).map(x => x.userDayId)
                .filter(x => x))]
        }

        this.service
            .approve(uniqueUserDayIds)
            .then((x) => this.refreshTable())
            .catch((err) => {
                this.showErrorMessage(err.message);
            })
    }


    handleUnlockReportedDay() {
        //TODO
        let uniqueUserDayIds = []
        if (WeekViewDateUtils.isSpecialWeek(this.state.criteria.selectedDay)) {
            uniqueUserDayIds = [...new Set(this.getCurrentWeekEvents().map(x => x.userDayId).filter((x) => x !== undefined))]
        } else {
            uniqueUserDayIds = [...new Set(this.state.list.flatMap((x) => x.events).flatMap(x => x).map(x => x.userDayId)
                .filter(x => x))]
        }

        this.service
            .open(uniqueUserDayIds)
            .then((x) => this.refreshTable())
            .catch((err) => {
                this.showErrorMessage(err.message);
            })
    }


    getCurrentWeekEvents() {
        //funkcja do pobrania eventów z aktualnie wybranego tygodnia, case tydzien a b 
        //np. zatwierdzanie, odblokowanie musi byc dla eventow z odpowiedniego tygodnia

        let result=[]
        if (WeekViewDateUtils.isSpecialWeek(this.state.criteria.selectedDay)) {
            const selectedWeek = this.state.selectedWeek;
            if (selectedWeek === 0) {
                const startOfWeekMonth = WeekViewDateUtils.getWeekRange(this.state.criteria.selectedDay)[0].month() //miesiac z pocz. tygodnia
                        //miesiac z pocz. tygodnia

                        result = this.state.list
                        .flatMap(
                            element =>
                                element.events.flatMap((x) => x)
                        ).filter((x) => moment(x?.day).month() === startOfWeekMonth) //filtruj eventy z drugiego tygodnia
            } else {
                const endOfWeekMonth = WeekViewDateUtils.getWeekRange(this.state.criteria.selectedDay)[1].month() //miesiac z końca tygodnia
                result = this.state.list
                    .flatMap(
                        element =>
                            element.events.flatMap((x) => x)
                    ).filter((x) => moment(x?.day).month() === endOfWeekMonth) //filtruj eventy z drugiego tygodnia
            }
      
            return result;
        }
    }

    getCurrentWeekEventsForRow(rowIndex) {
        //funkcja do pobrania eventów z aktualnie wybranego tygodnia, case tydzien a b 
        //np. usuwanie musi byc z odpowiedniego tygodnia, a nie dla calego wiersza

        let result = []
        if (WeekViewDateUtils.isSpecialWeek(this.state.criteria.selectedDay)) {
            const selectedWeek = this.state.selectedWeek;
            if (selectedWeek === 0) {
                const startOfWeekMonth = WeekViewDateUtils.getWeekRange(this.state.criteria.selectedDay)[0].month() //miesiac z pocz. tygodnia
                result = this.state.list[rowIndex].events
                    .flatMap(events =>
                        events?.filter(
                            event => event.id !== undefined
                                && moment(event.day).month() === startOfWeekMonth //filtruj eventy z pierwszego tygodnia dla danego wiersza
                        )
                    )
            } else {
                const endOfWeekMonth = WeekViewDateUtils.getWeekRange(this.state.criteria.selectedDay)[1].month() //miesiac z końca tygodnia
                result = this.state.list[rowIndex].events
                    .flatMap(events =>
                        events?.filter(
                            event => event.id !== undefined
                                && moment(event.day).month() === endOfWeekMonth //filtruj eventy z drugiego tygodnia dla danego wiersza
                        )
                    )
            }
            return result;
        }
    }



    renderView() {
        const renderHeader = this.props.renderHeader === undefined || this.props.renderHeader === true;
        const userDays = //this.state.list.length > 0 ? this.state.list.flatMap(x => x.events).filter(x => x).flatMap(x => x).map(x => x.userDayId) :
            this.state.userDays
        return (
            <DivContainer colClass=''>
                <CustomMessages id='custom-messages' ref={(el) => (this.messages = el)} />
                <BlockUi
                    tag='div'
                    blocking={this.state.blocking || this.state.loading}
                    loader={this.loader}
                    rendered={!this.props.embedded}
                >
                    <div style={{ minHeight: "900px" }}>
                        <Card
                            className='list-card'
                        >   <UserRedirectWarningDialog
                                visible={this.state.dialogVisibile}
                                onHide={(e) => this.setState({ dialogVisibile: false })}
                             >
                                <span>{t('userReporting.userRedirectWarning')}</span>
                            </UserRedirectWarningDialog>
                            <YesNoDialog
                                header={t('userReporting.recordDeleteHeader')}
                                onHide={() => {
                                    this.setState({ showConfirmDeleteActivityDialog: false });
                                }}
                                onChange={(type, x, target) => {
                                    this.blockUi();
                                    if (target.value) {

                                        let data = this.state.isActiveModel.map;
                                        for (const [key, value] of Object.entries(data)) {
                                            const arr = key.split(',').map(Number);
                                            if (arr[0] === this.state.rowToDelete) {
                                                data[[arr[0], arr[1]]] = false; //"zamknij" wszystkie inplace z usuwanego wiersza, 
                                                //"niezamkniecie" spowoduje niemozliwosc przejscia na inne zakladki bo nadal w state pozostana otwarte pola
                                            }
                                        }
                                        this.setState({
                                            isActiveModel: {
                                                map: data
                                            }
                                        }, () => {
                                            let toDelete = this.state.eventsToDelete;
                                            if (WeekViewDateUtils.isSpecialWeek(this.state.criteria.selectedDay)) {
                                                toDelete = this.getCurrentWeekEventsForRow(this.state.rowToDelete).map(x=>x.id);
                                            }
                                            
                                            this.service
                                                .deleteRow(toDelete)
                                                .then(() => {
                                                    this.unblockUi();
                                                    this.setState({
                                                        eventsToDelete: [],
                                                        showConfirmDeleteActivityDialog: false,
                                                        rowToDelete: undefined
                                                    });
                                                    this.refreshTable();
                                                })
                                                .catch(() => {
                                                    this.unblockUi();
                                                    this.showErrorMessage(t('userReporting.recordDeleteError'));
                                                    const data = this.getClosedInplaceComponentsMapForRow(this.state.rowToDelete);
                                                    this.setState({
                                                        eventsToDelete: [],
                                                        showConfirmDeleteActivityDialog: false,
                                                        rowToDelete: undefined,
                                                        isActiveModel: {
                                                            map: data
                                                        }
                                                    });
                                                    this.refreshTable();
                                                });
                                        })
                                    } else {
                                        this.unblockUi();
                                        const data = this.getClosedInplaceComponentsMapForRow(this.state.rowToDelete);
                                        this.setState({
                                            eventsToDelete: [],
                                            showConfirmDeleteActivityDialog: false,
                                            rowToDelete: undefined,
                                            isActiveModel: {
                                                map: data
                                            }
                                        });
                                        this.refreshTable();
                                    }
                                }}
                                visible={this.state.showConfirmDeleteActivityDialog}
                            >
                                {t('userReporting.deleteMessage')}
                            </YesNoDialog>
                            <DivContainer colClass='row' rendered={this.props.hideFilters !== true}>
                                {this.renderHeaderDetails()}
                            </DivContainer>
                            <DivContainer colClass='row' rendered={renderHeader}>{this.renderHeader()}</DivContainer>
                            <TabView
                                activeIndex={this.state.activeIndex}
                                onTabChange={(e) => {
                                    if (!this.isDirty()) {
                                        this.setState({ activeIndex: e.index }, () => {
                                            this.props.history.push({
                                                search: TabViewUtils.createQueryString({ activeIndex: e.index }),
                                            });
                                        });
                                    }else{
                                        this.setState({
                                            dialogVisibile: true
                                        })
                                    }
                                }}
                            >
                                <TabPanel header='Aktywności'>
                                    {this.renderDataTable(this.prepareColumns())}
                                </TabPanel>
                                {this.authService.isUserInAnyRole('ROLE_EVENT_LOG_LIST_VIEW', 'ROLE_REPORT_OWN_TIME') ?
                                    <TabPanel header='Dziennik zdarzeń'>
                                        {userDays.length > 0 ?
                                            <LogEntryListContainer
                                                objectType='USER_DAY'
                                                affectedObjectIdList={userDays}
                                                expandFilters={false}
                                                renderHeader={false}
                                            />
                                            :
                                            null}
                                        {userDays.length === 0 ?
                                            <LogEntryListContainer
                                                objectType='USER_DAY'
                                                affectedObjectIdList={[]}
                                                expandFilters={false}
                                                renderHeader={false}
                                                noRefresh={true} //nie powinno byc requesta kiedy nie ma user day na dzien
                                            />
                                            :
                                            null}
                                    </TabPanel>
                                    :
                                    null
                                }
                            </TabView>
                        </Card>
                    </div>
                </BlockUi>
            </DivContainer>
        );
    }


    render() {
        return (
            <div className='container-fluid projectcategory-list' id='report-week-container'>
                <BreadcrumbsItem to='/email-list'>{''}</BreadcrumbsItem>
                <Prompt
                    when={this.isDirty()} //true jesli przynajmniej jedno pole jest edytowane
                    message={(location) => { //kiedy user chce przejsc na innna zakladke w apce i isDirty true 
                        //-> wyswietlenie dialogu
                        this.setState({
                            dialogVisibile: true
                        })
                        return false; //-> zablokowanie przejscia
                    }}
                ></Prompt>
                {this.getApproveReportedDayDialog()}
                {this.getUnlockReportedDayDialog()}
                {this.renderView()}
            </div>
        );
    }
}


class WeekViewUtils{
    static getIsActive(rowIndex, columnIndex, isActiveModel) {
        return isActiveModel?.map[[rowIndex, columnIndex]]
    }
}

class TabViewUtils {
    static createQueryString(queryObject = {}) {
        let queryString = Object.keys(queryObject)
            .filter((key) => queryObject[key] && !(Array.isArray(queryObject[key]) && !queryObject[key].length))
            .map((key) => {
                return Array.isArray(queryObject[key]) ? queryObject[key].map(item => `${encodeURIComponent(key)}=${encodeURIComponent(item)}`).join('&') : `${encodeURIComponent(key)}=${encodeURIComponent(queryObject[key])}`;
            }).join('&');
        return queryString ? `?${queryString}` : "";
    };
}

class WeekViewDateUtils {

    static getWeekRange(day) {
        const daysFromMonday = Math.abs(moment(day).day() - 1);
        const daysUntilSunday = Math.abs(moment(day).day() - 7);

        const weekStart = moment(day).subtract(daysFromMonday, 'day');
        const weekEnd = moment(day).add(daysUntilSunday, 'day');

        return [weekStart, weekEnd];
    }

    static isSpecialWeek(date) {
        const range = this.getWeekRange(date);
        return range[0].month() !== range[1].month()
    }

    static formatTime(time) {
        if (time) {
            const hours = Math.floor(time / 60);
            const mins = time % 60;
            return `${hours}:${mins.toString().padStart(2, '0')}`;
        } else {
            return '';
        }
    }

    static getTimeHeader(date, dayIndex) {
        const day = t(`weekDaysStartingMonday.${dayIndex}`).slice(0, 1).toUpperCase() + t(`weekDaysStartingMonday.${dayIndex}`).slice(1, 3);
        const formattedDate = date.startsWith('0') ? date.slice(1) : date;
        return day + ' ' + formattedDate;
    }

    static formattedTimeToMinutes(time) {
        const split = time.split(':');
        return (Number(split[0] * 60)) + Number(split[1])
    }
}




WeekViewContainer.defaultProps = {
    lazy: true,
    renderHeader: true,
};

WeekViewContainer.propTypes = {

};

export default WeekViewContainer;